// import React, {
//   useState,
//   useEffect,
//   useRef,
//   useMemo,
//   useCallback,
//   useDeferredValue,
// } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Header } from "../../../components/Header/Header";
// import UploadModal from "../../Contract/UploadModal";
// import Cookies from "js-cookie";
// import SuccessPopup from "../SuccessPopup";
// import api from "../../chat/api";
// import { toast } from "react-toastify";
// import hotToast from "react-hot-toast";
// import PdfViewer from "../../chat/PdfViewer";
// import FilterDropdown from "./FilterDropdown";
// import CreateTagModals from "../CreateTagModals";
// import useSalesforcePicker from "../useSalesforcePicker";
// import SalesforceFileModal from "../SalesforceFileModal";
// import useGooglePicker from "../useGooglePicker";
// import CreateFolderModal from "../CreateFolderModal";
// import MoveToFolderPopup from "../MoveToFolderPopup";
// import RenameModal from "../RenameModal";
// import ViewAndIngestModal from "./ViewAndIngestModal";
// import { MoveToFolderIcon, SpinnerIcon, ColumnIcon } from "./Icons";
// import ColumnDropdown from "./ColumnDropdown";
// import AllSources from "./AllSources";
// import ContentLibrary from "./ContentLibrary";
// import Integrations from "./Integrations";
// import { Search } from "lucide-react";

// const KnowledgeBase = ({ isMenuOpen }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const currentPath = location.pathname.toLowerCase();

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isMoveToFolderPopupOpen, setIsMoveToFolderPopupOpen] = useState(false);
//   const [isBulkDelete, setIsBulkDelete] = useState(false);
//   const [contracts, setContracts] = useState([]);
//   const [folders, setFolders] = useState([]);
//   const [token, setToken] = useState(null);

//   const [columnPreferences, setColumnPreferences] = useState(() => {
//     const saved = localStorage.getItem("kb_column_prefs");
//     return saved ? JSON.parse(saved) : [];
//   });
//   const [isColumnDropdownOpen, setIsColumnDropdownOpen] = useState(false);

//   const [selectedFolderId, setSelectedFolderId] = useState(null);
//   const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [selectedContracts, setSelectedContracts] = useState([]);
//   const [selectedContractKeys, setSelectedContractKeys] = useState([]);

//   const [searchQuery, setSearchQuery] = useState("");
//   const deferredSearchQuery = useDeferredValue(searchQuery);

//   const [popupVisible, setPopupVisible] = useState(false);
//   const [popupTitle, setPopupTitle] = useState("");
//   const [popupMessage, setPopupMessage] = useState("");
//   const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
//   const [contractToDelete, setContractToDelete] = useState(null);
//   const actionMenuRefs = useRef({});
//   const fileInputRef = useRef(null);

//   const [deleteInProgress, setDeleteInProgress] = useState(false);
//   const [isCreateFolderModalOpen, setIsCreateFolderModalOpen] = useState(false);
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");

//   const [selectedFilterTags, setSelectedFilterTags] = useState([]);
//   const [filterTagObjects, setFilterTagObjects] = useState([]);
//   const [activeFilters, setActiveFilters] = useState({
//     fileTypes: [],
//     statuses: [],
//     tags: [],
//   });
//   const [tagsRefreshTrigger, setTagsRefreshTrigger] = useState(0);
//   const { isConnected, connect, disconnect, accessToken } = useGooglePicker();
//   const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
//   const [selectedFilePreview, setSelectedFilePreview] = useState(null);
//   const [isTagModalOpen, setIsTagModalOpen] = useState(false);
//   const [tagModalDocIds, setTagModalDocIds] = useState([]);
//   const [isSearchFocused, setIsSearchFocused] = useState(false);
//   const [file, setFile] = useState(null);
//   const [deleteSuccess, setDeleteSuccess] = useState(false);

//   const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);
//   const [renameItem, setRenameItem] = useState(null);
//   const [renameLoading, setRenameLoading] = useState(false);
//   const [results, setResults] = useState([]);
//   const [viewAndIngestItem, setViewAndIngestItem] = useState(null);

//   const [activePollingDocs, setActivePollingDocs] = useState(new Set());
//   const activePollingDocsRef = useRef(activePollingDocs);

//   const [isUploadingFiles, setIsUploadingFiles] = useState(false);
//   const [isRefreshingDocs, setIsRefreshingDocs] = useState(false);

//   const contractsRef = useRef(contracts);
//   const foldersRef = useRef(folders);

//   useEffect(() => {
//     contractsRef.current = contracts;
//   }, [contracts]);

//   useEffect(() => {
//     foldersRef.current = folders;
//   }, [folders]);

//   useEffect(() => {
//     activePollingDocsRef.current = activePollingDocs;
//   }, [activePollingDocs]);

//   // --- BUG FIX: Cleanup effect to prevent "Processing..." button from getting stuck ---
//   useEffect(() => {
//     const allDocs = [
//       ...contracts,
//       ...folders.flatMap((f) => f.documents || []),
//     ];

//     let keysToRemove = [];
//     allDocs.forEach((doc) => {
//       const docKey = doc.pdf_key || doc.key;
//       if (docKey && activePollingDocs.has(docKey)) {
//         const st = (doc.status || "").toLowerCase();
//         if (
//           st.includes("ready") ||
//           st === "ingested" ||
//           st === "completed" ||
//           st === "error" ||
//           st === "failed"
//         ) {
//           keysToRemove.push(docKey);
//         }
//       }
//     });

//     if (keysToRemove.length > 0) {
//       setActivePollingDocs((prev) => {
//         const next = new Set(prev);
//         keysToRemove.forEach((k) => next.delete(k));
//         return next;
//       });
//     }
//   }, [contracts, folders, activePollingDocs]);

//   const isKnowledgeBaseEmpty = useMemo(() => {
//     const hasNoFiles = !results || results.length === 0;
//     const hasNoFolderContent = folders.every((folder) => {
//       const sizeStr = folder.folder_size || "0 MB";
//       const sizeValue = parseFloat(sizeStr.replace(" MB", "")) || 0;
//       return sizeValue === 0;
//     });
//     return hasNoFiles && hasNoFolderContent;
//   }, [results, folders]);

//   const fetchContracts = useCallback(
//     async (isPolling = false) => {
//       if (!token) return;
//       if (!isPolling) setLoading(true);
//       try {
//         const orgId = Cookies.get("selected_org_id");
//         const docsUrl = orgId
//           ? `/api/v1/rfp/knowledge-base/documents/?organization_id=${encodeURIComponent(
//               orgId
//             )}`
//           : "/api/v1/rfp/knowledge-base/documents/";
//         const [docsResponse, columnsResponse] = await Promise.all([
//           api.get(docsUrl),
//           api
//             .get("/api/v1/rfp/column-preferences/?view=kb_documents")
//             .catch(() => null),
//         ]);

//         if (docsResponse && docsResponse.data) {
//           const { results, folders } = docsResponse.data;

//           const currentDocs = [
//             ...(contractsRef.current || []),
//             ...(foldersRef.current || []).flatMap((f) => f.documents || []),
//           ];

//           const getPreservedStatus = (docKey, docId) => {
//             const existing = currentDocs.find(
//               (d) => (d.pdf_key || d.key) === docKey || d.id === docId
//             );
//             return existing?.status || "processing";
//           };

//           const updatedFolders = (folders || []).map((folder) => ({
//             ...folder,
//             documents: (folder.documents || []).map((doc) => {
//               const docKey = doc.pdf_key || doc.key;
//               return {
//                 ...doc,
//                 status: doc.status
//                   ? doc.status
//                   : getPreservedStatus(docKey, doc.id),
//               };
//             }),
//           }));

//           const updatedResults = (results || []).map((doc) => {
//             const docKey = doc.pdf_key || doc.key;
//             return {
//               ...doc,
//               status: doc.status
//                 ? doc.status
//                 : getPreservedStatus(docKey, doc.id),
//             };
//           });

//           setResults(updatedResults);
//           setFolders(updatedFolders);
//           setContracts(updatedResults);
//         }

//         if (
//           columnsResponse &&
//           columnsResponse.data &&
//           columnsResponse.data.columns
//         ) {
//           setColumnPreferences(columnsResponse.data.columns);
//           localStorage.setItem(
//             "kb_column_prefs",
//             JSON.stringify(columnsResponse.data.columns)
//           );
//         }
//       } catch (error) {
//         console.error("Error fetching contracts:", error);
//       } finally {
//         if (!isPolling) setLoading(false);
//       }
//     },
//     [token]
//   );

//   const saveColumnPreferences = async (updatedColumns) => {
//     try {
//       const payload = {
//         columns: updatedColumns.map((col) => ({
//           name: col.name,
//           visible: col.visible === true || col.visible === "true",
//           order: col.order,
//         })),
//       };

//       localStorage.setItem("kb_column_prefs", JSON.stringify(payload.columns));

//       await api.patch(
//         "/api/v1/rfp/column-preferences/?view=kb_documents",
//         payload
//       );
//     } catch (error) {
//       console.error("Failed to save column preferences:", error);
//     }
//   };

//   const pollDocumentStatuses = useCallback(async () => {
//     const allDocs = [
//       ...contractsRef.current,
//       ...foldersRef.current.flatMap((f) => f.documents || []),
//     ];

//     const uniqueDocsMap = new Map();
//     allDocs.forEach((d) => {
//       const key = d.pdf_key || d.key;
//       if (key) uniqueDocsMap.set(key, d);
//     });

//     const pendingDocs = Array.from(uniqueDocsMap.values()).filter((doc) => {
//       const docKey = doc.pdf_key || doc.key;
//       if (!docKey || !activePollingDocsRef.current.has(docKey)) return false;

//       const st = (doc.status || "").toLowerCase();
//       return !(
//         st.includes("ready") ||
//         st === "ingested" ||
//         st === "completed" ||
//         st === "error" ||
//         st === "failed"
//       );
//     });

//     if (pendingDocs.length === 0) return;

//     try {
//       const statusPromises = pendingDocs.map(async (doc) => {
//         const docKey = doc.pdf_key || doc.key;
//         if (!docKey) return null;
//         try {
//           const res = await api.get(
//             `/api/v1/rfp/knowledge-base/documents/${docKey}/status/`
//           );

//           let rawNewStatus = doc.status;

//           if (res.data?.type === "completed") {
//             rawNewStatus = "ingested";
//           } else if (
//             res.data?.type === "review" ||
//             res.data?.message?.toLowerCase() === "ready for review"
//           ) {
//             rawNewStatus = "ready_for_review";
//           } else if (res.data?.status) {
//             rawNewStatus = res.data.status;
//           } else if (res.data?.message) {
//             rawNewStatus = res.data.message;
//           } else if (typeof res.data === "string" && res.data.trim() !== "") {
//             rawNewStatus = res.data;
//           }

//           if (!rawNewStatus) {
//             rawNewStatus = "processing";
//           }

//           if (rawNewStatus.toLowerCase() === "ready for review") {
//             rawNewStatus = "ready_for_review";
//           }

//           if (
//             (rawNewStatus.toLowerCase() === "failed" ||
//               rawNewStatus.toLowerCase() === "error") &&
//             doc.status?.toLowerCase() !== rawNewStatus.toLowerCase()
//           ) {
//             toast.error(`Processing failed for document: ${doc.name}`);
//           }

//           return { key: docKey, id: doc.id, status: rawNewStatus };
//         } catch (err) {
//           console.error(`Failed to fetch status for ${docKey}:`, err);
//           return null;
//         }
//       });

//       const statuses = (await Promise.all(statusPromises)).filter(Boolean);

//       if (statuses.length > 0) {
//         let hasChanges = false;
//         let requiresFullFetch = false;

//         statuses.forEach((s) => {
//           const existingDoc = allDocs.find(
//             (c) => (c.pdf_key || c.key) === s.key
//           );
//           if (existingDoc && existingDoc.status !== s.status) {
//             hasChanges = true;
//             const newSt = (s.status || "").toLowerCase();
//             if (
//               newSt.includes("ready") ||
//               newSt === "ingested" ||
//               newSt === "completed"
//             ) {
//               requiresFullFetch = true;
//             }
//           }
//         });

//         if (hasChanges) {
//           setActivePollingDocs((prev) => {
//             const next = new Set(prev);
//             statuses.forEach((s) => {
//               const newSt = (s.status || "").toLowerCase();
//               if (
//                 newSt.includes("ready") ||
//                 newSt === "ingested" ||
//                 newSt === "completed" ||
//                 newSt === "error" ||
//                 newSt === "failed"
//               ) {
//                 next.delete(s.key);
//               }
//             });
//             return next;
//           });

//           setContracts((prev) =>
//             prev.map((c) => {
//               const updated = statuses.find((s) => s.key === c.key);
//               return updated && updated.status !== c.status
//                 ? { ...c, status: updated.status }
//                 : c;
//             })
//           );

//           setFolders((prev) =>
//             prev.map((f) => {
//               if (!f.documents) return f;
//               return {
//                 ...f,
//                 documents: f.documents.map((d) => {
//                   const dKey = d.pdf_key || d.key;
//                   const updated = statuses.find((s) => s.key === dKey);
//                   return updated && updated.status !== d.status
//                     ? { ...d, status: updated.status }
//                     : d;
//                 }),
//               };
//             })
//           );

//           if (requiresFullFetch) {
//             setIsRefreshingDocs(true);
//             setTimeout(async () => {
//               await fetchContracts(true);
//               setIsRefreshingDocs(false);
//             }, 500);
//           }
//         }
//       }
//     } catch (error) {
//       console.error("Polling error:", error);
//     }
//   }, [fetchContracts]);

//   useEffect(() => {
//     const allDocs = [
//       ...contracts,
//       ...folders.flatMap((f) => f.documents || []),
//     ];

//     const hasPendingDocs = allDocs.some((doc) => {
//       const docKey = doc.pdf_key || doc.key;
//       if (!docKey || !activePollingDocs.has(docKey)) return false;

//       const st = (doc.status || "").toLowerCase();
//       return !(
//         st.includes("ready") ||
//         st === "ingested" ||
//         st === "completed" ||
//         st === "error" ||
//         st === "failed"
//       );
//     });

//     let intervalId;
//     if (hasPendingDocs) {
//       intervalId = setInterval(() => {
//         pollDocumentStatuses();
//       }, 3000);
//     }
//     return () => {
//       if (intervalId) clearInterval(intervalId);
//     };
//   }, [contracts, folders, pollDocumentStatuses, activePollingDocs]);

//   const hasProcessingMetaSummary = useMemo(() => {
//     const allDocs = [
//       ...contracts,
//       ...folders.flatMap((f) => f.documents || []),
//     ];
//     return allDocs.some(
//       (doc) => (doc.meta_summary || "").toLowerCase() === "processing"
//     );
//   }, [contracts, folders]);

//   useEffect(() => {
//     if (!hasProcessingMetaSummary || !token) return;

//     const orgId = Cookies.get("selected_org_id");
//     const docsUrl = orgId
//       ? `/api/v1/rfp/knowledge-base/documents/?organization_id=${encodeURIComponent(
//           orgId
//         )}`
//       : "/api/v1/rfp/knowledge-base/documents/";

//     const pollMetaSummary = async () => {
//       try {
//         const res = await api.get(docsUrl);
//         const data = res.data || {};
//         const fetchedResults = Array.isArray(data.results) ? data.results : [];
//         const fetchedFolders = Array.isArray(data.folders) ? data.folders : null;

//         const buildMap = (list) => {
//           const map = new Map();
//           list.forEach((f) => {
//             const k = f.pdf_key || f.key || f.id;
//             if (k != null) map.set(k, f);
//           });
//           return map;
//         };

//         const resultsMap = buildMap(fetchedResults);
//         setContracts((prev) =>
//           prev.map((c) => {
//             const k = c.pdf_key || c.key || c.id;
//             const updated = resultsMap.get(k);
//             if (!updated) return c;
//             return {
//               ...c,
//               meta_summary: updated.meta_summary,
//               summary: updated.summary,
//             };
//           })
//         );
//         setResults((prev) =>
//           prev.map((c) => {
//             const k = c.pdf_key || c.key || c.id;
//             const updated = resultsMap.get(k);
//             if (!updated) return c;
//             return {
//               ...c,
//               meta_summary: updated.meta_summary,
//               summary: updated.summary,
//             };
//           })
//         );

//         if (fetchedFolders) {
//           const folderDocMaps = new Map();
//           fetchedFolders.forEach((f) => {
//             folderDocMaps.set(f.id, buildMap(f.documents || []));
//           });
//           setFolders((prev) =>
//             prev.map((folder) => {
//               const docMap = folderDocMaps.get(folder.id);
//               if (!docMap || !folder.documents) return folder;
//               return {
//                 ...folder,
//                 documents: folder.documents.map((d) => {
//                   const k = d.pdf_key || d.key || d.id;
//                   const updated = docMap.get(k);
//                   if (!updated) return d;
//                   return {
//                     ...d,
//                     meta_summary: updated.meta_summary,
//                     summary: updated.summary,
//                   };
//                 }),
//               };
//             })
//           );
//         }
//       } catch (err) {
//         console.error("meta_summary polling error", err);
//       }
//     };

//     const intervalId = setInterval(pollMetaSummary, 2000);
//     return () => clearInterval(intervalId);
//   }, [hasProcessingMetaSummary, token]);

//   const handleFileChange = async (event) => {
//     const selectedFiles = Array.from(event.target.files || []);
//     if (selectedFiles.length === 0) return;

//     if (selectedFiles.length > 5) {
//       toast.error("You can only upload a maximum of 5 files at once.");
//       event.target.value = null;
//       return;
//     }

//     event.target.value = null;

//     const formData = new FormData();
//     selectedFiles.forEach((file) => formData.append("files", file));

//     setIsUploadingFiles(true);

//     try {
//       const endpoint = selectedFolderId
//         ? `/api/v1/rfp/knowledge-base/upload/?folder_id=${selectedFolderId}`
//         : "/api/v1/rfp/knowledge-base/upload/";

//       const response = await api.post(endpoint, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       const uploadedResults = response.data.results || [];
      
//       // 1. FILTER FIX: Ensure we only poll keys that actually exist
//       const validNewKeys = uploadedResults
//         .map((doc) => doc.pdf_key)
//         .filter(Boolean); // Removes undefined/null
        
//       if (validNewKeys.length > 0) {
//         setActivePollingDocs((prev) => new Set([...prev, ...validNewKeys]));
//       }

//       // 2. ERROR HANDLING FIX: Alert the user if any files failed
//       const failedDocs = uploadedResults.filter(doc => doc.status === "failed");
//       if (failedDocs.length > 0) {
//         toast.error(`${failedDocs.length} file(s) failed: ${failedDocs[0].reason || 'Duplicate detected'}`);
//       }

//       // 3. GHOST ROW FIX: Only add successfully started documents to the UI
//       const newDocs = uploadedResults
//         .filter((doc) => doc.pdf_key && doc.status !== "failed")
//         .map((doc) => ({
//           id: doc.doc_id,
//           key: doc.pdf_key,
//           name: doc.file,
//           status: doc.status || "uploading",
//           uploaded_at: new Date().toISOString(),
//           file_type: doc.file.split(".").pop()?.toLowerCase() || "pdf",
//           tags: [],
//         }));

//       if (selectedFolderId) {
//         setFolders((prevFolders) =>
//           prevFolders.map((f) => {
//             if (f.id === selectedFolderId) {
//               return {
//                 ...f,
//                 documents: [...newDocs, ...(f.documents || [])],
//               };
//             }
//             return f;
//           })
//         );
//       } else {
//         setContracts((prev) => [...newDocs, ...prev]);
//       }

//       setTimeout(() => {
//         pollDocumentStatuses();
//       }, 500);
//     } catch (error) {
//       console.error("Upload error:", error);
//       toast.error("Failed to upload file(s)");
//     } finally {
//       setIsUploadingFiles(false);
//     }
//   };
//   const handleChatButtonClick = () => {
//     if (isKnowledgeBaseEmpty) {
//       toast.warning("Upload files to chat with knowledge base");
//     } else {
//       navigate("/rfp-knowledgeBase/chat");
//     }
//   };

//   const {
//     isSFDCConnected,
//     handleConnectSFDC,
//     handleFetchSFDCFiles,
//     sfdcFiles,
//     isFetchingSFDCFiles,
//     showSFDCFileList,
//     setShowSFDCFileList,
//     handleSelectSFDCFiles,
//     verifySFDCConnection,
//     isSFDCUploading,
//     sfdcUploadItems,
//   } = useSalesforcePicker(setFile, setIsModalOpen, fetchContracts, "kb");

//   const {
//     isDriveConnected,
//     pickerLoaded,
//     handleConnectDrive,
//     openPicker,
//     verifyDriveConnection,
//   } = useGooglePicker(setFile, setIsModalOpen);

//   const openTagModalFor = useCallback((docIdOrIds) => {
//     const ids = Array.isArray(docIdOrIds) ? docIdOrIds : [docIdOrIds];
//     setTagModalDocIds(ids);
//     setIsTagModalOpen(true);
//   }, []);

//   const openCreateFolderModal = () => setIsCreateFolderModalOpen(true);
//   const closeCreateFolderModal = () => setIsCreateFolderModalOpen(false);

//   const handleCreateFolder = async (folderName) => {
//     if (!token) {
//       hotToast.error("No authentication token available");
//       return;
//     }
//     try {
//       const orgId = Cookies.get("selected_org_id");
//       const response = await api.post(
//         "/api/v1/rfp/knowledge-base/create-folder/",
//         {
//           folder_name: folderName,
//           // org_id: orgId ? parseInt(orgId, 10) : undefined,
//         }
//       );
//       if (response.status === 200 || response.status === 201) {
//         hotToast.success(`Folder created successfully!`);
//         fetchContracts();
//         return Promise.resolve();
//       }
//     } catch (error) {
//       hotToast.error(
//         error?.response?.data?.message || "Failed to create folder."
//       );
//       throw error;
//     }
//   };

//   function darkenColor(hex, amount = 0.4) {
//     if (!hex || !hex.startsWith("#")) return "#333";
//     const num = parseInt(hex.slice(1), 16);
//     let r = (num >> 16) & 255,
//       g = (num >> 8) & 255,
//       b = num & 255;
//     r = Math.floor(r * (1 - amount));
//     g = Math.floor(g * (1 - amount));
//     b = Math.floor(b * (1 - amount));
//     return `rgb(${r}, ${g}, ${b})`;
//   }

//   const handleFilterClear = () => {
//     setSelectedFilterTags([]);
//     setFilterTagObjects([]);
//     setActiveFilters({ fileTypes: [], statuses: [], tags: [] });
//     fetchContracts();
//   };

//   const handleFilterApply = (selectedFilters) => {
//     setSelectedFilterTags(selectedFilters.tags);
//     setActiveFilters(selectedFilters);

//     const params = {};
//     if (selectedFilters.tags.length > 0) {
//       params.tags = selectedFilters.tags.join(",");
//     }
//     if (selectedFilters.fileTypes.length > 0) {
//       params.file_type = selectedFilters.fileTypes.join(",").toLowerCase();
//     }
//     if (selectedFilters.statuses.length > 0) {
//       params.status = selectedFilters.statuses
//         .map((s) => s.toLowerCase().replace(/ /g, "_"))
//         .join(",");
//     }
//     const orgId = Cookies.get("selected_org_id");
//     if (orgId) {
//       params.organization_id = orgId;
//     }

//     api
//       .get("/api/v1/rfp/knowledge-base/documents/", { params })
//       .then((res) => {
//         const results = Array.isArray(res.data.results) ? res.data.results : [];
//         setFilterTagObjects(results);
//         setContracts(results);
//       })
//       .catch((err) => console.log(err, "Failed to apply filters."));
//   };

//   useEffect(() => {
//     if (isConnected && !hasOpenedPickerOnce) setHasOpenedPickerOnce(true);
//   }, [isConnected, hasOpenedPickerOnce]);

//   useEffect(() => {
//     const cookieToken = Cookies.get("access_token");
//     if (cookieToken) setToken(cookieToken);
//   }, []);

//   useEffect(() => {
//     verifySFDCConnection();
//     verifyDriveConnection();
//   }, []);

//   const toggleModal = () => setIsModalOpen((prev) => !prev);
//   const handleCancel = () => {
//     setSelectedContracts([]);
//     setIsModalOpen(false);
//     setPopupVisible(false);
//     setConfirmDeleteVisible(false);
//   };

//   const sortedFolders = useMemo(() => {
//     return [...folders].sort(
//       (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
//     );
//   }, [folders]);

//   const displayedFiles = useMemo(() => {
//     const query = deferredSearchQuery.toLowerCase().trim();
//     let sourceFiles = [];

//     if (selectedFolderId === null) {
//       sourceFiles = contracts;
//     } else {
//       const folder = folders.find((f) => f.id === selectedFolderId);
//       if (folder && folder.documents) {
//         sourceFiles = folder.documents.map((doc) => ({
//           ...doc,
//           isFolder: false,
//           file_url: doc.pdf_url || doc.file_url,
//           size_mb: doc.document_size || doc.size_mb,
//           uploaded_at: doc.uploaded_at || doc.created_at,
//         }));
//       }
//     }

//     let filtered = sourceFiles;

//     if (activeFilters.fileTypes && activeFilters.fileTypes.length > 0) {
//       const allowedTypes = activeFilters.fileTypes.map((t) => t.toLowerCase());
//       filtered = filtered.filter((file) => {
//         const fileExt =
//           file.file_type?.toLowerCase() ||
//           file.name?.split(".").pop()?.toLowerCase() ||
//           "";

//         if (
//           allowedTypes.includes("xlsx") &&
//           (fileExt === "xlsx" || fileExt === "xls" || fileExt === "csv")
//         )
//           return true;
//         if (
//           allowedTypes.includes("docx") &&
//           (fileExt === "docx" || fileExt === "doc" || fileExt === "txt")
//         )
//           return true;
//         if (allowedTypes.includes("pdf") && fileExt === "pdf") return true;

//         return allowedTypes.includes(fileExt);
//       });
//     }

//     if (activeFilters.statuses && activeFilters.statuses.length > 0) {
//       const allowedStatuses = activeFilters.statuses.map((s) =>
//         s.toLowerCase().replace(/ /g, "_")
//       );
//       filtered = filtered.filter((file) => {
//         const status = file.status?.toLowerCase() || "";
//         return allowedStatuses.includes(status);
//       });
//     }

//     if (query) {
//       filtered = filtered.filter((file) => {
//         const fileName = file.name?.toLowerCase() || "";
//         const fileTags = Array.isArray(file.tags)
//           ? file.tags.map((tag) => tag.name?.toLowerCase() || "").join(" ")
//           : "";
//         const fileType = file.file_type?.toLowerCase() || "";
//         return (
//           fileName.includes(query) ||
//           fileTags.includes(query) ||
//           fileType.includes(query)
//         );
//       });
//     }

//     return [...filtered].sort(
//       (a, b) => new Date(b.uploaded_at) - new Date(a.uploaded_at)
//     );
//   }, [
//     contracts,
//     folders,
//     selectedFolderId,
//     deferredSearchQuery,
//     activeFilters,
//   ]);

//   const isAllChecked =
//     selectedContracts.length === displayedFiles.length &&
//     displayedFiles.length > 0 &&
//     displayedFiles.every((item) => item.id);

//   const handleSelectAll = useCallback(() => {
//     if (isAllChecked) {
//       setSelectedContracts([]);
//       setSelectedContractKeys([]);
//     } else {
//       const allIds = displayedFiles.map((item) => item.id).filter(Boolean);
//       const allKeys = displayedFiles.map((item) => item.key).filter(Boolean);
//       setSelectedContracts(allIds);
//       setSelectedContractKeys(allKeys);
//     }
//   }, [isAllChecked, displayedFiles]);

//   const handleCheckboxChange = useCallback((id, key) => {
//     if (!id) return;
//     setSelectedContracts((prev) =>
//       prev.includes(id) ? prev.filter((cId) => cId !== id) : [...prev, id]
//     );
//     setSelectedContractKeys((prev) =>
//       prev.includes(key) ? prev.filter((cKey) => cKey !== key) : [...prev, key]
//     );
//   }, []);

//   useEffect(() => {
//     setSelectedContracts([]);
//     setSelectedContractKeys([]);
//     setIsActionMenuOpen(null);
//   }, [selectedFolderId]);

//   useEffect(() => {
//     if (token) fetchContracts();
//   }, [token, fetchContracts]);

//   const handleUploadSuccess = () => {
//     fetchContracts();
//     toggleModal();
//   };
//   const handleCloseModal = () => {
//     toggleModal();
//     fetchContracts();
//   };

//   const [actionMenuPosition, setActionMenuPosition] = useState({
//     top: 0,
//     left: 0,
//     openUpwards: false,
//   });
//   const toggleActionMenu = useCallback((index, event) => {
//     const MENU_HEIGHT = 230; // approx rendered height with all items
//     const rect = event.currentTarget.getBoundingClientRect();
//     const bottomSpace = window.innerHeight - rect.bottom;
//     const openUpwards = bottomSpace < MENU_HEIGHT;
  
//     setIsActionMenuOpen((prev) => (prev === index ? null : index));
//     setActionMenuPosition({
//       top: openUpwards ? rect.top : rect.bottom + 4,
//       left: rect.right,
//       openUpwards,
//     });
//   }, []);

//   const handleClickOutside = (event) => {
//     if (
//       isActionMenuOpen !== null &&
//       actionMenuRefs.current[isActionMenuOpen] &&
//       !actionMenuRefs.current[isActionMenuOpen].contains(event.target)
//     ) {
//       setIsActionMenuOpen(null);
//     }
//     if (
//       confirmDeleteVisible &&
//       event.target.closest(".popup-overlay") === null &&
//       !event.target.closest(".popup-box-delete")
//     ) {
//       setConfirmDeleteVisible(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [confirmDeleteVisible, isActionMenuOpen]);

//   const showPopup = (title, message) => {
//     setPopupTitle(title);
//     setPopupMessage(message);
//     setPopupVisible(true);
//   };
//   const closePopup = () => setPopupVisible(false);

//   const handleDelete = useCallback((item) => {
//     setIsActionMenuOpen(null);
//     setIsBulkDelete(false);
//     setContractToDelete({ folder_ids: [], doc_ids: [item.id] });
//     setConfirmDeleteVisible(true);
//   }, []);

//   const handleBulkDelete = useCallback(() => {
//     if (!selectedContracts || selectedContracts.length === 0) {
//       showPopup("Error", "Please select at least one item to delete.");
//       return;
//     }
//     setIsActionMenuOpen(null);
//     setIsBulkDelete(true);
//     setConfirmDeleteVisible(true);
//   }, [selectedContracts]);

//   const confirmDelete = async () => {
//     let payload;
//     if (isBulkDelete) {
//       const selectedItems = displayedFiles.filter((item) =>
//         selectedContracts.includes(item.id)
//       );
//       const doc_ids = selectedItems.map((item) => item.id).filter(Boolean);
//       payload = { doc_ids, folder_ids: [] };
//     } else {
//       payload = contractToDelete;
//     }

//     setDeleteInProgress(true);
//     try {
//       const res = await api.delete(
//         "/api/v1/rfp/knowledge-base/documents/delete/",
//         { data: payload }
//       );
//       if (res.status === 200) {
//         const documents = res?.data?.results?.documents || [];
//         const folders = res?.data?.results?.folders || [];
//         const allItems = [...documents, ...folders];
//         const failedItems = allItems.filter((item) => item.status === "error");
//         const deletedDocIds = documents
//           .filter((item) => item.status === "success")
//           .map((item) => item.identifier);
//         const deletedFolderIds = folders
//           .filter((item) => item.status === "success")
//           .map((item) => item.identifier);

//         setDeleteInProgress(false);

//         if (failedItems.length > 0) {
//           failedItems.forEach((item) => {
//             hotToast.error(
//               `Failed to delete (ID: ${item.identifier}): ${item.error || "Unknown error"}`
//             );
//           });
//         }

//         if (deletedDocIds.length > 0 || deletedFolderIds.length > 0) {
//           fetchContracts(true);
//         }

//         if (deletedDocIds.length > 0 || deletedFolderIds.length > 0 || allItems.length === 0) {
//           setDeleteSuccess(true);
//           setTimeout(() => {
//             setConfirmDeleteVisible(false);
//             setDeleteSuccess(false);
//             setContractToDelete(null);
//             setSelectedContracts([]);
//             setSelectedContractKeys([]);
//           }, 2000);
//         } else {
//           setConfirmDeleteVisible(false);
//           setContractToDelete(null);
//           setSelectedContracts([]);
//           setSelectedContractKeys([]);
//         }
//       }
//     } catch (error) {
//       setDeleteInProgress(false);
//       setDeleteSuccess(false);
//       const errorMessage =
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Failed to delete item(s).";
//       hotToast.error(errorMessage);
//     }
//   };

//   const formatDate = useCallback((dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "";
//     const day = String(date.getDate()).padStart(2, "0"),
//       month = String(date.getMonth() + 1).padStart(2, "0"),
//       year = date.getFullYear().toString().slice(-2);
//     return `${month}-${day}-${year}`;
//   }, []);

//   const getFileIcon = useCallback((item) => {
//     switch (item.file_type) {
//       case "pdf":
//         return "/pdff.svg";
//       case "xlsx":
//       case "xls":
//         return "/Xls.svg";
//       case "docx":
//       case "doc":
//         return "/docX.svg";
//       case "csv":
//         return "/CSV.svg";
//       case "txt":
//         return "/TXT.svg";
//       default:
//         return "/pdf.svg";
//     }
//   }, []);

//   const handleDownload = useCallback(async (item) => {
//     setIsActionMenuOpen(null);
//     const fileName = item.name || `document.${item.file_type || "file"}`;
//     try {
//       const response = await fetch(item.file_url);
//       if (!response.ok) throw new Error(`HTTP ${response.status}`);
//       const blob = await response.blob();
//       const blobUrl = URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = blobUrl;
//       link.download = fileName;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(blobUrl);
//     } catch (error) {
//       console.error("Download error:", error);
//       // Could not fetch the file for a renamed download (e.g. CORS) —
//       // fall back to opening it in a separate tab.
//       const opened = window.open(item.file_url, "_blank", "noopener,noreferrer");
//       if (!opened) toast.error("Failed to download file.");
//     }
//   }, []);

//   const hasSelectedFiles = () => selectedContracts.length > 0;
//   const getSelectedFilesCount = () => selectedContracts.length;

//   const handleMoveToFolder = () => {
//     if (!hasSelectedFiles()) return;
//     setIsMoveToFolderPopupOpen(true);
//   };

//   const handleSingleMoveToFolder = useCallback((item) => {
//     setIsActionMenuOpen(null);
//     if (item.id) {
//       setSelectedContracts([item.id]);
//       setSelectedContractKeys([item.key || item.pdf_key]);
//     }
//     setIsMoveToFolderPopupOpen(true);
//   }, []);

//   const handleMoveSuccess = () => {
//     fetchContracts();
//     setSelectedContracts([]);
//     setSelectedContractKeys([]);
//   };

//   const removeFileExtension = useCallback((filename) => {
//     if (!filename) return "N/A";
//     if (filename.includes(".")) {
//       const lastDotIndex = filename.lastIndexOf(".");
//       if (lastDotIndex > 0) return filename.substring(0, lastDotIndex);
//     }
//     return filename;
//   }, []);

//   const handleRenameClick = useCallback((item) => {
//     setIsActionMenuOpen(null);
//     setRenameItem(item);
//     setIsRenameModalOpen(true);
//   }, []);

//   const handleRenameSubmit = async (newName) => {
//     if (!renameItem || !newName.trim()) return;
//     setRenameLoading(true);
//     try {
//       const response = await api.put(
//         `/api/v1/readpdf/rename-doc/${renameItem.id}/`,
//         { new_name: newName }
//       );
//       if (response.status === 200) {
//         toast.success(`File renamed successfully!`);
//         setIsRenameModalOpen(false);
//         setRenameItem(null);
//         fetchContracts();
//       }
//     } catch (error) {
//       toast.error("Failed to rename file");
//     } finally {
//       setRenameLoading(false);
//     }
//   };

//   const handleCloseRenameModal = () => {
//     setIsRenameModalOpen(false);
//     setRenameItem(null);
//   };

//   const handleViewAndIngestOpen = useCallback((item) => {
//     setIsActionMenuOpen(null);
//     setViewAndIngestItem(item);
//   }, []);

//   const handleViewAndIngestClose = useCallback(() => {
//     setViewAndIngestItem(null);
//   }, []);

//   const handleApproveAndIngest = async (item) => {
//     const pdfKey = item.pdf_key || item.key;
//     try {
//       await api.post(`/api/v1/rfp/knowledge-base/documents/${pdfKey}/ingest/`, {
//         action: "approve",
//       });

//       setActivePollingDocs((prev) => new Set([...prev, pdfKey]));

//       const updateDocStatus = (docs) =>
//         docs.map((doc) =>
//           (doc.pdf_key || doc.key) === pdfKey
//             ? { ...doc, status: "processing" }
//             : doc
//         );

//       setContracts((prev) => updateDocStatus(prev));
//       setFolders((prev) =>
//         prev.map((f) => ({
//           ...f,
//           documents: updateDocStatus(f.documents || []),
//         }))
//       );

//       setTimeout(() => pollDocumentStatuses(), 1000);
//     } catch (error) {
//       toast.error("Failed to start ingestion.");
//       throw error;
//     }
//   };

//   const handleRejectAndDelete = async (item) => {
//     const pdfKey = item.pdf_key || item.key;
//     try {
//       const response = await api.delete(
//         `/api/v1/rfp/knowledge-base/documents/${pdfKey}/reject/`
//       );
//       fetchContracts();
//     } catch (error) {
//       toast.error("Failed to reject document.");
//       throw error;
//     }
//   };

//   const handleViewDocumentFromModal = (item) => {
//     setSelectedFilePreview({
//       pdf_url: item.file_url || item.pdf_url,
//       file_type: item.file_type,
//       name: item.name,
//     });
//   };

//   const tabs = [
//     { name: "All Sources", path: "/rfp-knowledgeBase/All-sources" },
//     { name: "Content Library", path: "/rfp-knowledgeBase/Content-library" },
//     { name: "Integrations", path: "/rfp-knowledgeBase/Integrations" },
//   ];
//   return (
//     <>
//       <input
//         ref={fileInputRef}
//         type="file"
//         multiple
//         className="hidden"
//         accept=".pdf,.jpeg,.jpg,.png,.csv,.xlsx,.xls,.docx,.doc"
//         onChange={handleFileChange}
//       />

//       <div className="flex flex-col w-full h-full min-h-0 overflow-hidden bg-[#FAFAFA]">
//         <div className="flex-shrink-0 bg-white">
//           <Header
//             name="Knowledge Base"
//             icon={""}
//             isMenuOpen={isMenuOpen}
//             isKnowledgeBasePage={true}
//             kbState={{
//               isKnowledgeBaseEmpty,
//               isDriveConnected,
//               pickerLoaded,
//               isSFDCConnected,
//               isProcessing:
//                 activePollingDocs.size > 0 ||
//                 isUploadingFiles ||
//                 isRefreshingDocs,
//             }}
//             kbHandlers={{
//               onChat: handleChatButtonClick,
//               onCreateFolder: openCreateFolderModal,
//               onAddDevice: () => fileInputRef.current?.click(),
//               onConnectDrive: handleConnectDrive,
//               onAddFromDrive: openPicker,
//               onConnectSFDC: handleConnectSFDC,
//               onAddFromSFDC: handleFetchSFDCFiles,
//             }}
//           />
//         </div>

//         <div className="flex justify-between items-center px-6 pt-2 pb-0 border-b border-[#00000036] bg-white flex-shrink-0 w-full">
//           <div className="flex items-center gap-4 border-b-[1px]">
//             {tabs.map((tab) => (
//               <button
//                 key={tab.name}
//                 onClick={() => navigate(tab.path)}
//                 className={`font-outfit text-[15px] pb-0 px-1 transition-colors ${
//                   currentPath.includes(tab.path.toLowerCase())
//                     ? "text-[#BB42AE] font-semibold border-b-[2px] border-[#BB42AE]"
//                     : "text-[#707070] font-medium  border-[#E6E6E6]"
//                 }`}
//               >
//                 {tab.name}
//               </button>
//             ))}
//           </div>

//           <div className="flex items-center gap-3 pb-3">
//           <div className="relative inline-flex items-center gap-2 z-[50]">
//   <FilterDropdown
//     folderId={selectedFolderId} // <-- ADD THIS LINE
//     initialFilters={activeFilters}
//     onApply={handleFilterApply}
//     onClear={handleFilterClear}
//     tagsRefreshTrigger={tagsRefreshTrigger}
//   />
// </div>

//             <div className="relative inline-flex items-center gap-2">
//               <button
//                 onClick={() => setIsColumnDropdownOpen((p) => !p)}
//                 className={`flex items-center gap-2 px-3 py-1.5 border rounded text-[14px] font-outfit transition-colors ${
//                   isColumnDropdownOpen
//                     ? "border-[#BB42AE] text-[#BB42AE] bg-[#F8F3FF]"
//                     : "border-[#00000036] text-[#52525B] hover:bg-gray-50"
//                 }`}
//               >
//                 <ColumnIcon /> Columns
//               </button>
//               {isColumnDropdownOpen && (
//                 <>
//                   <div
//                     className="fixed inset-0 z-[998] bg-transparent"
//                     onClick={() => setIsColumnDropdownOpen(false)}
//                   />
//                   <ColumnDropdown
//                     columns={columnPreferences}
//                     setColumns={setColumnPreferences}
//                     onSave={saveColumnPreferences}
//                     onClose={() => setIsColumnDropdownOpen(false)}
//                   />
//                 </>
//               )}
//             </div>

//             <div className="relative w-[200px]">
//               <Search
//                 className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600"
//                 size={18}
//               />
//               <input
//                 type="text"
//                 placeholder="Search Documents..."
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 onFocus={() => setIsSearchFocused(true)}
//                 onBlur={() => setIsSearchFocused(false)}
//                 className="w-full pl-10 pr-4 border border-[#00000036] rounded-md focus:outline-none focus:border-[#C95EBE] focus:ring-1 focus:ring-[#C95EBE] box-border h-[35px] text-[14px] leading-[20px] transition-all"
//               />
//             </div>
//           </div>
//         </div>

//         {currentPath.includes("/rfp-knowledgebase/all-sources") && (
//           <AllSources
//             contracts={contracts}
//             folders={folders}
//             selectedFolderId={selectedFolderId}
//             setSelectedFolderId={setSelectedFolderId}
//             sortedFolders={sortedFolders}
//             openCreateFolderModal={openCreateFolderModal}
//             selectedContracts={selectedContracts}
//             getSelectedFilesCount={getSelectedFilesCount}
//             hasSelectedFiles={hasSelectedFiles}
//             handleMoveToFolder={handleMoveToFolder}
//             handleSingleMoveToFolder={handleSingleMoveToFolder}
//             handleBulkDelete={handleBulkDelete}
//             handleCancel={handleCancel}
//             displayedFiles={displayedFiles}
//             loading={loading}
//             isAllChecked={isAllChecked}
//             handleSelectAll={handleSelectAll}
//             handleCheckboxChange={handleCheckboxChange}
//             getFileIcon={getFileIcon}
//             removeFileExtension={removeFileExtension}
//             darkenColor={darkenColor}
//             openTagModalFor={openTagModalFor}
//             formatDate={formatDate}
//             toggleActionMenu={toggleActionMenu}
//             isActionMenuOpen={isActionMenuOpen}
//             setIsActionMenuOpen={setIsActionMenuOpen}
//             actionMenuPosition={actionMenuPosition}
//             actionMenuRefs={actionMenuRefs}
//             setSelectedFilePreview={setSelectedFilePreview}
//             handleRenameClick={handleRenameClick}
//             handleDownload={handleDownload}
//             handleDelete={handleDelete}
//             handleViewAndIngest={handleViewAndIngestOpen}
//             columnPreferences={columnPreferences}
//           />
//         )}

//         {currentPath.includes("/rfp-knowledgebase/content-library") && <ContentLibrary />}
//         {currentPath.includes("/rfp-knowledgebase/integrations") && <Integrations />}

//         {popupVisible && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//             <div className="popup-box">
//               <h2>{popupTitle}</h2> <p>{popupMessage}</p>
//               <button onClick={closePopup} className="popup-close-button">
//                 Close
//               </button>
//             </div>
//           </div>
//         )}

//         {confirmDeleteVisible && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//             <div className="popup-box-delete bg-white rounded-lg p-6 w-[400px] shadow-xl">
//               <h2 className="text-lg font-bold mb-2">
//                 Are you sure you want to delete the selected item(s)?
//               </h2>
//               <p className="text-gray-600 text-sm mb-6">
//                 Once deleted, the selected item(s) will be permanently removed.
//                 This action cannot be undone.
//               </p>
//               <div className="flex gap-3 justify-end">
//                 <button
//                   onClick={() => setConfirmDeleteVisible(false)}
//                   disabled={deleteInProgress || deleteSuccess}
//                   className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={confirmDelete}
//                   disabled={deleteInProgress || deleteSuccess}
//                   className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50"
//                 >
//                   {deleteInProgress ? "Deleting..." : deleteSuccess ? "Deleted" : "Delete"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* PERFORMANCE FIX: Conditionally render heavy modals to reduce DOM nodes */}
//         {isModalOpen && (
//           <UploadModal
//             isOpen={isModalOpen}
//             onClose={handleCloseModal}
//             onUploadSuccess={handleUploadSuccess}
//             type={"rfp_knowledge"}
//             file={file}
//           />
//         )}

//         {selectedFilePreview && (
//           <div
//             className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 backdrop-blur-sm"
//             onClick={() => setSelectedFilePreview(null)}
//           >
//             <div
//               className="bg-white rounded-lg shadow-lg w-[55vw] h-[80vh] overflow-hidden relative"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <PdfViewer pdfUrl={selectedFilePreview.pdf_url} />
//             </div>
//           </div>
//         )}

//         {isTagModalOpen && (
//           <CreateTagModals
//             isOpen={isTagModalOpen}
//             onClose={() => setIsTagModalOpen(false)}
//             documentId={tagModalDocIds}
//             displayedFiles={displayedFiles}
//             onTagUpdate={() => {
//               fetchContracts();
//               setTagsRefreshTrigger((prev) => prev + 1);
//             }}
//             onClearSelection={() => {
//               setSelectedContracts([]);
//               setSelectedContractKeys([]);
//             }}
//           />
//         )}

//         {isCreateFolderModalOpen && (
//           <CreateFolderModal
//             isOpen={isCreateFolderModalOpen}
//             onClose={closeCreateFolderModal}
//             onCreate={handleCreateFolder}
//             token={token}
//           />
//         )}

//         {showSuccessPopup && (
//           <SuccessPopup
//             isOpen={showSuccessPopup}
//             message={successMessage}
//             onClose={() => setShowSuccessPopup(false)}
//           />
//         )}

//         {showSFDCFileList && (
//           <SalesforceFileModal
//             show={showSFDCFileList}
//             onClose={() => setShowSFDCFileList(false)}
//             sfdcFiles={sfdcFiles}
//             onSelect={handleSelectSFDCFiles}
//             isFetching={isFetchingSFDCFiles}
//           />
//         )}

//         {isMoveToFolderPopupOpen && (
//           <MoveToFolderPopup
//             isOpen={isMoveToFolderPopupOpen}
//             onClose={() => setIsMoveToFolderPopupOpen(false)}
//             selectedDocuments={selectedContracts}
//             onMoveSuccess={handleMoveSuccess}
//             currentFolders={folders}
//           />
//         )}

//         {isRenameModalOpen && (
//           <RenameModal
//             isOpen={isRenameModalOpen}
//             onClose={handleCloseRenameModal}
//             onRename={handleRenameSubmit}
//             currentName={renameItem?.name || ""}
//             loading={renameLoading}
//             isFolder={renameItem?.isFolder || false}
//             itemType={renameItem?.isFolder ? "folder" : "file"}
//           />
//         )}

//         {!!viewAndIngestItem && (
//           <ViewAndIngestModal
//             isOpen={!!viewAndIngestItem}
//             onClose={handleViewAndIngestClose}
//             item={viewAndIngestItem}
//             onRejectAndDelete={handleRejectAndDelete}
//             onApproveAndIngest={handleApproveAndIngest}
//             onViewDocument={handleViewDocumentFromModal}
//           />
//         )}

//         {isSFDCUploading && (
//           <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/30 backdrop-blur-[2px]">
//             <div className="bg-white rounded-xl shadow-lg w-[400px] max-h-[70vh] flex flex-col p-5">
//               <h2 className="text-[16px] font-semibold text-[#1A1A1A] font-[Outfit] mb-1">
//                 Uploading from Salesforce…
//               </h2>
//               <div
//                 className="overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-[rgba(115,96,123,0.4)]"
//                 style={{ maxHeight: "200px" }}
//               >
//                 {sfdcUploadItems.map((item) => (
//                   <div
//                     key={item.id}
//                     className="mb-4 last:mb-0 border border-[rgba(0,0,0,0.06)] rounded-lg px-3 py-2 bg-[#FFF]"
//                   >
//                     <div className="flex items-start justify-between">
//                       <div className="flex-1 min-w-0">
//                         <div className="text-[14px] font-medium text-[#171717] font-[Outfit] truncate">
//                           {item.title}
//                         </div>
//                       </div>
//                       <div className="ml-2 flex-shrink-0">
//                         {item.status === "completed" ? (
//                           <img src="/right-success-upload.svg" alt="Done" className="w-5 h-5" />
//                         ) : item.status === "error" || item.status === "failed" ? (
//                           <img src="/cross-icon.svg" alt="Error" className="w-5 h-5" />
//                         ) : (
//                           <SpinnerIcon className="animate-spin h-5 w-5 text-[#8B55DD]" />
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default KnowledgeBase;

import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  useMemo,
  useCallback,
  useDeferredValue,
} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Header } from "../../../components/Header/Header";
import Cookies from "js-cookie";
import SuccessPopup from "../SuccessPopup";
import api from "../../chat/api";
import hotToast from "react-hot-toast";
import PdfViewer from "../../chat/PdfViewer";
import FilterDropdown from "./FilterDropdown";
import CreateTagModals from "../CreateTagModals";
import useSalesforcePicker from "../useSalesforcePicker";
import SalesforceFileModal from "../SalesforceFileModal";
import useKbGoogleDrive from "./useKbGoogleDrive";
import CreateFolderModal from "../CreateFolderModal";
import FolderPickerModal from "./FolderPickerModal";
import RenameModal from "../RenameModal";
import ViewAndIngestModal from "./ViewAndIngestModal";
import { MoveToFolderIcon, SpinnerIcon, ColumnIcon } from "./Icons";
import ColumnDropdown from "./ColumnDropdown";
import AllSources from "./AllSources";
import ContentLibrary from "./ContentLibrary";
import Integrations from "./Integrations";
import OrganizationMemory from "./OrganizationMemory";
import { Search } from "lucide-react";
import useIsKbReviewer from "../../../utils/useIsKbReviewer";
import useKnowledgeBaseStore from "../../../store/useKnowledgeBaseStore";
import { markOnboarding } from "../../../onboarding/onboardingStore";
import {
  UNFILED,
  orderFolders,
  sortDocuments,
  applyDocumentOrder,
  sha256Hex,
  statusKey,
} from "./kbHelpers";
import DuplicateUploadModal from "./DuplicateUploadModal";


// Per-batch upload cap, enforced identically for device and Google Drive uploads
// (the backend applies the same limit in GoogleDriveImportAPI).
const MAX_UPLOAD_FILES = 5;


// Files still being sent aren't on the server yet, so a list refresh keeps their rows.
const keepUploadPlaceholders = (placeholders, folderList, resultList) => {
  placeholders.forEach(({ doc, folderId }) => {
    if (!folderId) {
      resultList.unshift(doc);
      return;
    }
    const folder = folderList.find((f) => f.id === folderId);
    if (folder) folder.documents = [doc, ...(folder.documents || [])];
  });
};


const KnowledgeBase = ({ isMenuOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();

  // Reviewers are read-only in the KB: mutating controls are disabled below.
  const isReviewer = useIsKbReviewer();


  const [isBulkDelete, setIsBulkDelete] = useState(false);
  // ── KB list state now lives in a shared Zustand store (mirrors My Projects).
  // The setters keep the same setState-like API (value OR updater), so every
  // existing setContracts/setFolders/setResults/setLoading call works unchanged.
  const contracts = useKnowledgeBaseStore((s) => s.documents);
  const setContracts = useKnowledgeBaseStore((s) => s.setDocuments);
  const folders = useKnowledgeBaseStore((s) => s.folders);
  const setFolders = useKnowledgeBaseStore((s) => s.setFolders);
  const [token, setToken] = useState(null);


  const [columnPreferences, setColumnPreferences] = useState(() => {
    const saved = localStorage.getItem("kb_column_prefs");
    return saved ? JSON.parse(saved) : [];
  });
  const [isColumnDropdownOpen, setIsColumnDropdownOpen] = useState(false);


  // null = All Files, UNFILED = "Not in any folder", otherwise a real folder id.
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const realFolderId =
    selectedFolderId !== null && selectedFolderId !== UNFILED ? selectedFolderId : null;
  const [sortKey, setSortKey] = useState("added");
  const [sortDir, setSortDir] = useState("desc");
  const [isCreatingFolderInline, setIsCreatingFolderInline] = useState(false);
  const [draggingDoc, setDraggingDoc] = useState(null);
  // Uploads that match a document already in the KB; they are never uploaded again.
  const [dupNotice, setDupNotice] = useState(null);
  // Each running add/move/remove, so several can show their in-progress look at once.
  const [pendingActions, setPendingActions] = useState([]);
  const [creatingFolderName, setCreatingFolderName] = useState(null);
  // The name from a folder create that failed, so the box can show it again.
  const [draftFolderName, setDraftFolderName] = useState("");
  // { mode: "add" | "move", docs } while the folder picker is open.
  const [folderPicker, setFolderPicker] = useState(null);
  // Which nested child of "Previous Proposals" is open: 'won', 'delivered',
  // or null for the parent folder itself (everything). Not a folder id —
  // these children are tier views, not rows in readpdf_folder.
  const [selectedProposalTier, setSelectedProposalTier] = useState(null);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
  const loading = useKnowledgeBaseStore((s) => s.loading);
  const setLoading = useKnowledgeBaseStore((s) => s.setLoading);
  const [selectedContracts, setSelectedContracts] = useState([]);
  const [selectedContractKeys, setSelectedContractKeys] = useState([]);


  const [searchQuery, setSearchQuery] = useState("");
  const deferredSearchQuery = useDeferredValue(searchQuery);


  const [popupVisible, setPopupVisible] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [contractToDelete, setContractToDelete] = useState(null);
  const actionMenuRefs = useRef({});
  const fileInputRef = useRef(null);


  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const [isCreateFolderModalOpen, setIsCreateFolderModalOpen] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");


  const [selectedFilterTags, setSelectedFilterTags] = useState([]);
  const [filterTagObjects, setFilterTagObjects] = useState([]);
  const [activeFilters, setActiveFilters] = useState({
    fileTypes: [],
    statuses: [],
    tags: [],
  });
  const [tagsRefreshTrigger, setTagsRefreshTrigger] = useState(0);
  const [selectedFilePreview, setSelectedFilePreview] = useState(null);
  const [isTagModalOpen, setIsTagModalOpen] = useState(false);
  const [tagModalDocIds, setTagModalDocIds] = useState([]);
  // Docs whose tags are saving/refreshing — shows an "Applying…" cell state.
  const [applyingTagDocIds, setApplyingTagDocIds] = useState([]);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);


  // Google Drive import overlay — the network round trip is server-side, so this
  // reports "which files are being fetched" rather than a per-file byte progress.
  const [isImportingFromDrive, setIsImportingFromDrive] = useState(false);
  const [driveImportItems, setDriveImportItems] = useState([]);


  const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);
  const [renameItem, setRenameItem] = useState(null);
  const [renameLoading, setRenameLoading] = useState(false);
  const results = useKnowledgeBaseStore((s) => s.results);
  const setResults = useKnowledgeBaseStore((s) => s.setResults);
  const [viewAndIngestItem, setViewAndIngestItem] = useState(null);


  const [activePollingDocs, setActivePollingDocs] = useState(new Set());
  const activePollingDocsRef = useRef(activePollingDocs);


  // Rows shown the moment files are picked, until the server answers: key -> { doc, folderId }.
  const uploadPlaceholdersRef = useRef(new Map());


  const contractsRef = useRef(contracts);
  const foldersRef = useRef(folders);
  // When the user last changed folders or order here; older background refreshes are ignored.
  const localChangeAt = useRef(0);
  const markLocalChange = () => {
    localChangeAt.current = Date.now();
  };


  useEffect(() => {
    contractsRef.current = contracts;
  }, [contracts]);


  useEffect(() => {
    foldersRef.current = folders;
  }, [folders]);


  useEffect(() => {
    activePollingDocsRef.current = activePollingDocs;
  }, [activePollingDocs]);


  // --- BUG FIX: Cleanup effect to prevent "Processing..." button from getting stuck ---
  useEffect(() => {
    const allDocs = [
      ...contracts,
      ...folders.flatMap((f) => f.documents || []),
    ];


    let keysToRemove = [];
    allDocs.forEach((doc) => {
      const docKey = doc.pdf_key || doc.key;
      if (docKey && activePollingDocs.has(docKey)) {
        const st = (doc.status || "").toLowerCase();
        if (
          st.includes("ready") ||
          st === "ingested" ||
          st === "completed" ||
          st === "error" ||
          st === "failed"
        ) {
          keysToRemove.push(docKey);
        }
      }
    });


    if (keysToRemove.length > 0) {
      setActivePollingDocs((prev) => {
        const next = new Set(prev);
        keysToRemove.forEach((k) => next.delete(k));
        return next;
      });
    }
  }, [contracts, folders, activePollingDocs]);


  // Any real file still in progress gets watched, so a row can't sit on "Ingesting" until a reload.
  useEffect(() => {
    const keysToAdd = [
      ...contracts,
      ...folders.flatMap((f) => f.documents || []),
    ]
      .filter((doc) => statusKey(doc.status) === "processing")
      .map((doc) => doc.pdf_key || doc.key)
      .filter((key) => key && !key.startsWith("uploading-") && !activePollingDocs.has(key));
    if (keysToAdd.length > 0) {
      setActivePollingDocs((prev) => new Set([...prev, ...keysToAdd]));
    }
  }, [contracts, folders, activePollingDocs]);


  const isKnowledgeBaseEmpty = useMemo(() => {
    const hasNoFiles = !results || results.length === 0;
    const hasNoFolderContent = folders.every((folder) => {
      const sizeStr = folder.folder_size || "0 MB";
      const sizeValue = parseFloat(sizeStr.replace(" MB", "")) || 0;
      return sizeValue === 0;
    });
    return hasNoFiles && hasNoFolderContent;
  }, [results, folders]);


  const fetchContracts = useCallback(
    async (isPolling = false) => {
      if (!token) return;
      if (!isPolling) setLoading(true);
      const startedAt = Date.now();
      try {
        const orgId = Cookies.get("selected_org_id");
        const docsUrl = orgId
          ? `/api/v1/rfp/knowledge-base/documents/?organization_id=${encodeURIComponent(
              orgId
            )}`
          : "/api/v1/rfp/knowledge-base/documents/";
        const [docsResponse, columnsResponse] = await Promise.all([
          api.get(docsUrl),
          api
            .get("/api/v1/rfp/column-preferences/?view=kb_documents")
            .catch(() => null),
        ]);


        // A background refresh that started before the latest local change would undo it on
        // screen; that change already triggers its own refresh, so this one is dropped.
        const outdated = isPolling && localChangeAt.current > startedAt;
        if (docsResponse && docsResponse.data && !outdated) {
          const { results, folders } = docsResponse.data;


          const currentDocs = [
            ...(contractsRef.current || []),
            ...(foldersRef.current || []).flatMap((f) => f.documents || []),
          ];


          const getPreservedStatus = (docKey, docId) => {
            const existing = currentDocs.find(
              (d) => (d.pdf_key || d.key) === docKey || d.id === docId
            );
            return existing?.status || "processing";
          };


          const updatedFolders = (folders || []).map((folder) => ({
            ...folder,
            documents: (folder.documents || []).map((doc) => {
              const docKey = doc.pdf_key || doc.key;
              return {
                ...doc,
                status: doc.status
                  ? doc.status
                  : getPreservedStatus(docKey, doc.id),
              };
            }),
          }));


          const updatedResults = (results || []).map((doc) => {
            const docKey = doc.pdf_key || doc.key;
            return {
              ...doc,
              status: doc.status
                ? doc.status
                : getPreservedStatus(docKey, doc.id),
            };
          });
          keepUploadPlaceholders(uploadPlaceholdersRef.current, updatedFolders, updatedResults);


          setResults(updatedResults);
          setFolders(updatedFolders);
          setContracts(updatedResults);
        }


        if (
          columnsResponse &&
          columnsResponse.data &&
          columnsResponse.data.columns
        ) {
          setColumnPreferences(columnsResponse.data.columns);
          localStorage.setItem(
            "kb_column_prefs",
            JSON.stringify(columnsResponse.data.columns)
          );
        }
      } catch (error) {
        console.error("Error fetching contracts:", error);
      } finally {
        if (!isPolling) setLoading(false);
      }
    },
    [token]
  );


  const saveColumnPreferences = async (updatedColumns) => {
    try {
      const payload = {
        columns: updatedColumns.map((col) => ({
          name: col.name,
          visible: col.visible === true || col.visible === "true",
          order: col.order,
        })),
      };


      localStorage.setItem("kb_column_prefs", JSON.stringify(payload.columns));


      await api.patch(
        "/api/v1/rfp/column-preferences/?view=kb_documents",
        payload
      );
    } catch (error) {
      console.error("Failed to save column preferences:", error);
    }
  };


  const pollDocumentStatuses = useCallback(async () => {
    const allDocs = [
      ...contractsRef.current,
      ...foldersRef.current.flatMap((f) => f.documents || []),
    ];


    const uniqueDocsMap = new Map();
    allDocs.forEach((d) => {
      const key = d.pdf_key || d.key;
      if (key) uniqueDocsMap.set(key, d);
    });


    const pendingDocs = Array.from(uniqueDocsMap.values()).filter((doc) => {
      const docKey = doc.pdf_key || doc.key;
      if (!docKey || !activePollingDocsRef.current.has(docKey)) return false;


      const st = (doc.status || "").toLowerCase();
      return !(
        st.includes("ready") ||
        st === "ingested" ||
        st === "completed" ||
        st === "error" ||
        st === "failed"
      );
    });


    if (pendingDocs.length === 0) return;


    try {
      const statusPromises = pendingDocs.map(async (doc) => {
        const docKey = doc.pdf_key || doc.key;
        if (!docKey) return null;
        try {
          const res = await api.get(
            `/api/v1/rfp/knowledge-base/documents/${docKey}/status/`
          );


          let rawNewStatus = doc.status;


          if (res.data?.type === "completed") {
            rawNewStatus = "ingested";
          } else if (
            res.data?.type === "review" ||
            res.data?.message?.toLowerCase() === "ready for review"
          ) {
            rawNewStatus = "ready_for_review";
          } else if (res.data?.type === "error") {
            rawNewStatus = "error";
          } else if (res.data?.status) {
            rawNewStatus = res.data.status;
          } else if (res.data?.message) {
            rawNewStatus = res.data.message;
          } else if (typeof res.data === "string" && res.data.trim() !== "") {
            rawNewStatus = res.data;
          }


          if (!rawNewStatus) {
            rawNewStatus = "processing";
          }


          if (rawNewStatus.toLowerCase() === "ready for review") {
            rawNewStatus = "ready_for_review";
          }


          if (
            (rawNewStatus.toLowerCase() === "failed" ||
              rawNewStatus.toLowerCase() === "error") &&
            doc.status?.toLowerCase() !== rawNewStatus.toLowerCase()
          ) {
            hotToast.error(`Processing failed for document: ${doc.name}`);
          }


          return { key: docKey, id: doc.id, status: rawNewStatus };
        } catch (err) {
          console.error(`Failed to fetch status for ${docKey}:`, err);
          return null;
        }
      });


      const statuses = (await Promise.all(statusPromises)).filter(Boolean);


      if (statuses.length > 0) {
        let hasChanges = false;
        let requiresFullFetch = false;


        statuses.forEach((s) => {
          const existingDoc = allDocs.find(
            (c) => (c.pdf_key || c.key) === s.key
          );
          if (existingDoc && existingDoc.status !== s.status) {
            hasChanges = true;
            const newSt = (s.status || "").toLowerCase();
            if (
              newSt.includes("ready") ||
              newSt === "ingested" ||
              newSt === "completed"
            ) {
              requiresFullFetch = true;
            }
          }
        });


        if (hasChanges) {
          setActivePollingDocs((prev) => {
            const next = new Set(prev);
            statuses.forEach((s) => {
              const newSt = (s.status || "").toLowerCase();
              if (
                newSt.includes("ready") ||
                newSt === "ingested" ||
                newSt === "completed" ||
                newSt === "error" ||
                newSt === "failed"
              ) {
                next.delete(s.key);
              }
            });
            return next;
          });


          setContracts((prev) =>
            prev.map((c) => {
              const updated = statuses.find((s) => s.key === c.key);
              return updated && updated.status !== c.status
                ? { ...c, status: updated.status }
                : c;
            })
          );


          setFolders((prev) =>
            prev.map((f) => {
              if (!f.documents) return f;
              return {
                ...f,
                documents: f.documents.map((d) => {
                  const dKey = d.pdf_key || d.key;
                  const updated = statuses.find((s) => s.key === dKey);
                  return updated && updated.status !== d.status
                    ? { ...d, status: updated.status }
                    : d;
                }),
              };
            })
          );


          if (requiresFullFetch) {
            // The summary and folder check finish a few seconds after a file is ready, so ask again.
            [500, 4000, 10000].forEach((ms) => setTimeout(() => fetchContracts(true), ms));
          }
        }
      }
    } catch (error) {
      console.error("Polling error:", error);
    }
  }, [fetchContracts]);


  useEffect(() => {
    const allDocs = [
      ...contracts,
      ...folders.flatMap((f) => f.documents || []),
    ];


    const hasPendingDocs = allDocs.some((doc) => {
      const docKey = doc.pdf_key || doc.key;
      if (!docKey || !activePollingDocs.has(docKey)) return false;


      const st = (doc.status || "").toLowerCase();
      return !(
        st.includes("ready") ||
        st === "ingested" ||
        st === "completed" ||
        st === "error" ||
        st === "failed"
      );
    });


    let intervalId;
    if (hasPendingDocs) {
      intervalId = setInterval(() => {
        pollDocumentStatuses();
      }, 3000);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [contracts, folders, pollDocumentStatuses, activePollingDocs]);


  const hasProcessingMetaSummary = useMemo(() => {
    const allDocs = [
      ...contracts,
      ...folders.flatMap((f) => f.documents || []),
    ];
    return allDocs.some(
      (doc) => (doc.meta_summary || "").toLowerCase() === "processing"
    );
  }, [contracts, folders]);


  useEffect(() => {
    if (!hasProcessingMetaSummary || !token) return;


    const orgId = Cookies.get("selected_org_id");
    const docsUrl = orgId
      ? `/api/v1/rfp/knowledge-base/documents/?organization_id=${encodeURIComponent(
          orgId
        )}`
      : "/api/v1/rfp/knowledge-base/documents/";


    const pollMetaSummary = async () => {
      try {
        const res = await api.get(docsUrl);
        const data = res.data || {};
        const fetchedResults = Array.isArray(data.results) ? data.results : [];
        const fetchedFolders = Array.isArray(data.folders) ? data.folders : null;


        const buildMap = (list) => {
          const map = new Map();
          list.forEach((f) => {
            const k = f.pdf_key || f.key || f.id;
            if (k != null) map.set(k, f);
          });
          return map;
        };


        const resultsMap = buildMap(fetchedResults);
        setContracts((prev) =>
          prev.map((c) => {
            const k = c.pdf_key || c.key || c.id;
            const updated = resultsMap.get(k);
            if (!updated) return c;
            return {
              ...c,
              meta_summary: updated.meta_summary,
              summary: updated.summary,
            };
          })
        );
        setResults((prev) =>
          prev.map((c) => {
            const k = c.pdf_key || c.key || c.id;
            const updated = resultsMap.get(k);
            if (!updated) return c;
            return {
              ...c,
              meta_summary: updated.meta_summary,
              summary: updated.summary,
            };
          })
        );


        if (fetchedFolders) {
          const folderDocMaps = new Map();
          fetchedFolders.forEach((f) => {
            folderDocMaps.set(f.id, buildMap(f.documents || []));
          });
          setFolders((prev) =>
            prev.map((folder) => {
              const docMap = folderDocMaps.get(folder.id);
              if (!docMap || !folder.documents) return folder;
              return {
                ...folder,
                documents: folder.documents.map((d) => {
                  const k = d.pdf_key || d.key || d.id;
                  const updated = docMap.get(k);
                  if (!updated) return d;
                  return {
                    ...d,
                    meta_summary: updated.meta_summary,
                    summary: updated.summary,
                  };
                }),
              };
            })
          );
        }
      } catch (err) {
        console.error("meta_summary polling error", err);
      }
    };


    const intervalId = setInterval(pollMetaSummary, 2000);
    return () => clearInterval(intervalId);
  }, [hasProcessingMetaSummary, token]);


  // Shared tail of every KB upload, whatever the source (device, Google Drive, …).
  // The backend returns the same `results` payload for all of them, so the
  // optimistic row insert, failure toasts and status polling live in one place.
  const applyUploadResults = useCallback(
    // `appliedTier` is passed ONLY by callers whose endpoint actually applied
    // it server-side. Without it the optimistic row has no evidence_tier, so
    // it renders under "Submitted" (the catch-all) and visibly jumps to
    // "Won"/"Delivered" a second later when the real row arrives. Guessing it
    // for a caller that didn't send one would just invert that flicker.
    (uploadedResults, appliedTier = null) => {
      const results = uploadedResults || [];


      const validNewKeys = results.map((doc) => doc.pdf_key).filter(Boolean);
      if (validNewKeys.length > 0) {
        setActivePollingDocs((prev) => new Set([...prev, ...validNewKeys]));
      }


      const failedDocs = results.filter((doc) => doc.status === "failed");
      if (failedDocs.length > 0) {
        // One toast per distinct reason so "2 duplicates + 1 too large" doesn't
        // collapse into a single misleading message.
        const byReason = new Map();
        failedDocs.forEach((doc) => {
          const reason = doc.reason || doc.error || "Upload failed";
          byReason.set(reason, [...(byReason.get(reason) || []), doc.file]);
        });
        byReason.forEach((names, reason) => {
          const label = names.length === 1 ? names[0] : `${names.length} files`;
          hotToast.error(`${label}: ${reason}`);
        });
      }


      const newDocs = results
        .filter((doc) => doc.pdf_key && doc.status !== "failed")
        .map((doc) => ({
          id: doc.doc_id,
          key: doc.pdf_key,
          name: doc.file,
          status: doc.status || "uploading",
          uploaded_at: new Date().toISOString(),
          file_type: doc.file?.split(".").pop()?.toLowerCase() || "pdf",
          tags: [],
          ...(appliedTier ? { evidence_tier: appliedTier } : {}),
        }));


      if (newDocs.length > 0) {
        if (realFolderId) {
          setFolders((prevFolders) =>
            prevFolders.map((f) =>
              f.id === realFolderId
                ? { ...f, documents: [...newDocs, ...(f.documents || [])] }
                : f
            )
          );
        } else {
          setContracts((prev) => [...newDocs, ...prev]);
        }


        setTimeout(() => {
          pollDocumentStatuses();
        }, 500);
      }


      return newDocs.length;
    },
    [realFolderId, setContracts, setFolders, pollDocumentStatuses]
  );


  const handleFileChange = async (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    if (selectedFiles.length === 0) return;


    if (selectedFiles.length > MAX_UPLOAD_FILES) {
      hotToast.error(`You can only upload a maximum of ${MAX_UPLOAD_FILES} files at once.`);
      event.target.value = null;
      return;
    }


    event.target.value = null;
    const placeholderKeys = addUploadPlaceholders(selectedFiles, realFolderId, selectedProposalTier);


    // Same SHA-256 the backend stores, so a renamed copy is still caught.
    let matches = {};
    let hashes = [];
    try {
      hashes = await Promise.all(selectedFiles.map(sha256Hex));
      const orgId = Cookies.get("selected_org_id");
      const res = await api.post("/api/v1/rfp/knowledge-base/documents/check-duplicates/", {
        hashes,
        organization_id: orgId || null,
      });
      matches = res.data?.matches || {};
    } catch (error) {
      console.error("Duplicate check failed, uploading as usual:", error);
    }

    // The same file picked twice is uploaded or reviewed once.
    const seen = new Set();
    const picked = selectedFiles
      .map((file, i) => ({ file, hash: hashes[i], match: matches[hashes[i]], placeholderKey: placeholderKeys[i] }))
      .filter(({ hash }) => !hash || (!seen.has(hash) && seen.add(hash)));
    const repeated = selectedFiles.length - picked.length;
    if (repeated > 0) {
      hotToast(`${repeated} repeated ${repeated === 1 ? "file was" : "files were"} left out of this upload.`);
    }

    const duplicates = picked.filter((item) => item.match);
    const freshItems = picked.filter((item) => !item.match);
    const fresh = freshItems.map((item) => item.file);
    if (duplicates.length > 0) {
      setDupNotice({ items: duplicates, otherCount: fresh.length });
    }
    // Repeats and duplicates won't be sent, so their rows go now.
    const sending = freshItems.map((item) => item.placeholderKey);
    removeUploadPlaceholders(placeholderKeys.filter((key) => !sending.includes(key)));

    await uploadFiles(fresh, realFolderId, selectedProposalTier, sending);
  };


  const addUploadPlaceholders = (files, folderId, tier) => {
    const stamp = Date.now();
    const docs = files.map((file, i) => ({
      key: `uploading-${stamp}-${i}`,
      name: file.name,
      status: "uploading",
      uploaded_at: new Date().toISOString(),
      file_type: file.name.split(".").pop()?.toLowerCase() || "pdf",
      document_size: `${(file.size / (1024 * 1024)).toFixed(2)} MB`,
      tags: [],
      ...(tier ? { evidence_tier: tier } : {}),
    }));
    docs.forEach((doc) => uploadPlaceholdersRef.current.set(doc.key, { doc, folderId: folderId || null }));
    if (folderId) {
      setFolders((prev) =>
        prev.map((f) => (f.id === folderId ? { ...f, documents: [...docs, ...(f.documents || [])] } : f))
      );
    } else {
      setContracts((prev) => [...docs, ...prev]);
    }
    return docs.map((doc) => doc.key);
  };


  const removeUploadPlaceholders = (keys) => {
    if (!keys.length) return;
    keys.forEach((key) => uploadPlaceholdersRef.current.delete(key));
    const keep = (list) => (list || []).filter((d) => !keys.includes(d.key));
    setContracts(keep);
    setFolders((prev) => prev.map((f) => (f.documents ? { ...f, documents: keep(f.documents) } : f)));
  };


  const uploadFiles = async (files, folderId, tier, placeholderKeys = []) => {
    if (!files.length) return 0;
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));


    try {
      const orgId = Cookies.get("selected_org_id");
      const params = new URLSearchParams();
      if (folderId) params.append("folder_id", folderId);
      if (orgId) params.append("organization_id", orgId);
      // Uploading while a nested view ("Won" / "Delivered") is open means the
      // file belongs to THAT state — the folder alone can't say so, since all
      // three children share one real folder.
      if (tier) params.append("evidence_tier", tier);
      const queryString = params.toString();
      const endpoint = queryString
        ? `/api/v1/rfp/knowledge-base/upload/?${queryString}`
        : "/api/v1/rfp/knowledge-base/upload/";


      const response = await api.post(endpoint, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });


      // The real rows take the placeholders' place in the same update.
      removeUploadPlaceholders(placeholderKeys);
      const uploaded = applyUploadResults(response.data?.results, tier);
      if (uploaded > 0) markOnboarding("kb");
      return uploaded;
    } catch (error) {
      console.error("Upload error:", error);
      removeUploadPlaceholders(placeholderKeys);
      hotToast.error(
        error?.response?.data?.error || "Failed to upload file(s)"
      );
      return 0;
    }
  };


  const handleChatButtonClick = () => {
    if (isKnowledgeBaseEmpty) {
      hotToast("Upload files to chat with knowledge base", { icon: "⚠️" });
    } else {
      navigate("/rfp-knowledgeBase/chat");
    }
  };


  const {
    isSFDCConnected,
    handleConnectSFDC,
    handleFetchSFDCFiles,
    sfdcFiles,
    isFetchingSFDCFiles,
    showSFDCFileList,
    setShowSFDCFileList,
    handleSelectSFDCFiles,
    verifySFDCConnection,
    isSFDCUploading,
    sfdcUploadItems,
  } = useSalesforcePicker(fetchContracts, "kb");


  // The picker callback is handed to the hook as a stable dispatcher so the
  // picker never has to be rebuilt, while `handleDriveFilesPicked` (defined just
  // below) always sees the current folder / org selection.
  const driveFilesPickedRef = useRef(null);
  const {
    isDriveConnected,
    pickerLoaded,
    isOpeningPicker: isOpeningDrivePicker,
    handleConnectDrive,
    openPicker,
    verifyDriveConnection,
  } = useKbGoogleDrive(
    useCallback((ids, docs) => driveFilesPickedRef.current?.(ids, docs), [])
  );


  // ── Google Drive → Knowledge Base ────────────────────────────────────────
  // Only ids cross the wire; the backend downloads/exports the bytes and pushes
  // them through the same upload endpoint the device flow uses.
  const handleDriveFilesPicked = useCallback(
    async (fileIds, pickedDocs) => {
      if (!fileIds?.length) return;


      if (fileIds.length > MAX_UPLOAD_FILES) {
        hotToast.error(
          `You can only upload a maximum of ${MAX_UPLOAD_FILES} files at once.`
        );
        return;
      }


      setDriveImportItems(
        (pickedDocs || []).map((doc) => ({
          id: doc.id,
          name: doc.name || "Untitled",
        }))
      );
      setIsImportingFromDrive(true);


      try {
        const orgId = Cookies.get("selected_org_id");
        const response = await api.post("/api/v1/accounts/google-drive/import/", {
          file_ids: fileIds,
          folder_id: realFolderId || null,
          organization_id: orgId || null,
        });


        const imported = applyUploadResults(response.data?.results);
        if (imported > 0) {
          markOnboarding("kb");
          hotToast.success(
            imported === 1
              ? "1 file imported from Google Drive."
              : `${imported} files imported from Google Drive.`
          );
        }
      } catch (error) {
        console.error("Google Drive import error:", error);
        const detail = error?.response?.data?.error;
        if (error?.response?.status === 401) {
          // Access was revoked between picking and importing — re-probe so the
          // menu falls back to "Connect Drive".
          verifyDriveConnection();
          hotToast.error(detail || "Google Drive access expired. Please reconnect.");
        } else {
          hotToast.error(detail || "Failed to import files from Google Drive.");
        }
      } finally {
        setIsImportingFromDrive(false);
        setDriveImportItems([]);
      }
    },
    [realFolderId, applyUploadResults, verifyDriveConnection]
  );


  useEffect(() => {
    driveFilesPickedRef.current = handleDriveFilesPicked;
  }, [handleDriveFilesPicked]);


  const openTagModalFor = useCallback((docIdOrIds) => {
    const ids = Array.isArray(docIdOrIds) ? docIdOrIds : [docIdOrIds];
    setTagModalDocIds(ids);
    setIsTagModalOpen(true);
  }, []);


  const openCreateFolderModal = () => setIsCreateFolderModalOpen(true);
  const closeCreateFolderModal = () => setIsCreateFolderModalOpen(false);


  const handleCreateFolder = async (folderName) => {
    if (!token) {
      hotToast.error("No authentication token available");
      return;
    }
    try {
      const orgId = Cookies.get("selected_org_id");
      const response = await api.post(
        "/api/v1/rfp/knowledge-base/create-folder/",
        {
          folder_name: folderName,
          org_id: orgId ? parseInt(orgId, 10) : undefined,
        }
      );
      if (response.status === 200 || response.status === 201) {
        await fetchContracts(true);
        closeCreateFolderModal();
        const newId = response.data?.folder?.id;
        if (newId) {
          setSelectedFolderId(newId);
          setSelectedProposalTier(null);
        }
        hotToast.success(`Folder created successfully!`);
        return Promise.resolve();
      }
    } catch (error) {
      hotToast.error(
        error?.response?.data?.message || "Failed to create folder."
      );
      throw error;
    }
  };

  const folderNameTaken = (name, exceptId = null) =>
    folders.some(
      (f) => f.id !== exceptId && f.name.trim().toLowerCase() === name.trim().toLowerCase()
    );

  const startCreateFolder = () => {
    if (currentPath.includes("/rfp-knowledgebase/all-sources")) {
      setIsCreatingFolderInline(true);
    } else {
      openCreateFolderModal();
    }
  };

  // Creates a folder without opening it; returns the new folder, or null when it failed.
  const createFolderQuietly = async (name) => {
    const trimmed = (name || "").trim();
    if (!trimmed) return null;
    if (folderNameTaken(trimmed)) {
      hotToast.error("A folder with that name already exists");
      return null;
    }
    try {
      const orgId = Cookies.get("selected_org_id");
      const response = await api.post("/api/v1/rfp/knowledge-base/create-folder/", {
        folder_name: trimmed,
        org_id: orgId ? parseInt(orgId, 10) : undefined,
      });
      const folder = response.data?.folder;
      if (!folder?.id) throw new Error("No folder returned");
      // Shown straight away, so it works even if the refresh after it fails.
      markLocalChange();
      setFolders((prev) =>
        prev.some((f) => f.id === folder.id)
          ? prev
          : [...prev, { ...folder, name: folder.name || trimmed, is_default: false, documents: [] }]
      );
      fetchContracts(true);
      return folder;
    } catch (error) {
      hotToast.error(error?.response?.data?.message || "Failed to create folder.");
      return null;
    }
  };

  const handleInlineCreateFolder = async (name) => {
    const trimmed = (name || "").trim();
    if (!trimmed) {
      setIsCreatingFolderInline(false);
      return;
    }
    if (folderNameTaken(trimmed)) {
      hotToast.error("A folder with that name already exists");
      return false;
    }
    setIsCreatingFolderInline(false);
    setCreatingFolderName(trimmed);
    const folder = await createFolderQuietly(trimmed);
    setCreatingFolderName(null);
    if (!folder) {
      setDraftFolderName(trimmed);
      setIsCreatingFolderInline(true);
      return;
    }
    setDraftFolderName("");
    setSelectedFolderId(folder.id);
    setSelectedProposalTier(null);
    hotToast.success(`Created folder “${folder.name || trimmed}”`);
  };

  const handleRenameFolder = async (folder, name) => {
    const trimmed = (name || "").trim();
    if (!trimmed || trimmed === folder.name) return true;
    if (folderNameTaken(trimmed, folder.id)) {
      hotToast.error("A folder with that name already exists");
      return false;
    }
    markLocalChange();
    setFolders((prev) => prev.map((f) => (f.id === folder.id ? { ...f, name: trimmed } : f)));
    try {
      await api.put(`/api/v1/readpdf/rename-folder/${folder.id}/`, { new_name: trimmed, ...orgParam() });
      fetchContracts(true);
    } catch (error) {
      setFolders((prev) => prev.map((f) => (f.id === folder.id ? { ...f, name: folder.name } : f)));
      hotToast.error(error?.response?.data?.msg || "Couldn't rename this folder.");
    }
    return true;
  };

  // The server needs the workspace to treat the owner's older personal folders as workspace folders.
  const orgParam = () => {
    const id = Cookies.get("selected_org_id");
    return id ? { organization_id: id } : {};
  };

  const moveDocuments = (body) =>
    api.post("/api/v1/rfp/knowledge-base/documents/move/", { ...body, ...orgParam() });

  const docsLabel = (docs) => (docs.length === 1 ? `“${docs[0].name}”` : `${docs.length} documents`);

  // Every add, move and remove shows a working message that turns into the result in place,
  // and marks the documents and target folder as busy until the server answers.
  const runFolderAction = async ({ docs, folderId, working, done, failed, request, apply }) => {
    markLocalChange();
    const toastId = hotToast.loading(working);
    const docIds = docs.map((d) => d.id);
    const docKeys = docs.map((d) => d.key || d.pdf_key).filter(Boolean);
    setPendingActions((prev) => [...prev, { id: toastId, docIds, folderId }]);
    try {
      await request();
      if (apply) apply();
      // Only the documents this action touched leave the selection.
      setSelectedContracts((prev) => prev.filter((id) => !docIds.includes(id)));
      setSelectedContractKeys((prev) => prev.filter((key) => !docKeys.includes(key)));
      hotToast.success(done, { id: toastId });
      fetchContracts(true);
      return true;
    } catch (error) {
      hotToast.error(error?.response?.data?.error || error?.response?.data?.msg || failed, { id: toastId });
      return false;
    } finally {
      setPendingActions((prev) => prev.filter((p) => p.id !== toastId));
    }
  };

  const withoutDocs = (list, ids) => (list || []).filter((d) => !ids.includes(d.id));
  const plainDocs = (docs) => docs.map(({ folderIds, isFolder, ...rest }) => rest);

  // A document lives in one folder only: moving puts it in this folder and takes it out of any other.
  // folderFix: the Wrong folder move, which also lets the file's trust level follow the new folder.
  const moveDocsToFolder = (docs, folder, { folderFix = false } = {}) => {
    const toMove = docs.filter(
      (d) => d.id && !((d.folderIds || []).length === 1 && d.folderIds[0] === folder.id)
    );
    if (!toMove.length) {
      hotToast(`${docs.length === 1 ? "It's" : "They're"} already in ${folder.name}`);
      return Promise.resolve(true);
    }
    const ids = toMove.map((d) => d.id);
    const moved = plainDocs(toMove).map((d) => (folderFix ? { ...d, folder_check: null } : d));
    return runFolderAction({
      docs: toMove,
      folderId: folder.id,
      working: `Moving ${docsLabel(toMove)} to ${folder.name}...`,
      done: `Moved ${docsLabel(toMove)} to ${folder.name}`,
      failed: "Couldn't move to this folder.",
      request: () =>
        moveDocuments({ doc_ids: ids, from_all: true, to_folder_id: folder.id, ...(folderFix ? { folder_fix: true } : {}) }),
      apply: () => {
        setFolders((prev) =>
          prev.map((f) =>
            f.id === folder.id
              ? { ...f, documents: [...moved, ...withoutDocs(f.documents, ids)] }
              : { ...f, documents: withoutDocs(f.documents, ids) }
          )
        );
        setContracts((prev) => withoutDocs(prev, ids));
      },
    });
  };

  const setFolderCheck = (docId, value) => {
    const update = (list) => (list || []).map((d) => (d.id === docId ? { ...d, folder_check: value } : d));
    setContracts(update);
    setFolders((prev) => prev.map((f) => (f.documents ? { ...f, documents: update(f.documents) } : f)));
  };

  const handleFolderCheckMove = (doc) => {
    const name = doc?.folder_check?.suggested;
    const folder = folders.find((f) => f.is_default && f.name === name);
    if (!folder) {
      hotToast.error(`Couldn't find the ${name} folder.`);
      return Promise.resolve(false);
    }
    return moveDocsToFolder([doc], folder, { folderFix: true });
  };

  const handleFolderCheckKeep = async (doc) => {
    if (!doc?.id) return false;
    markLocalChange();
    const before = doc.folder_check;
    setFolderCheck(doc.id, null);
    try {
      await api.post(`/api/v1/rfp/knowledge-base/documents/${doc.id}/folder-check/dismiss/`, orgParam());
      return true;
    } catch (error) {
      setFolderCheck(doc.id, before);
      hotToast.error(error?.response?.data?.error || "Couldn't update this document.");
      return false;
    }
  };

  // Dropped on a folder in the left panel, from any view.
  const handleMoveDocToFolder = (doc, folder) => {
    setDraggingDoc(null);
    if (!doc?.id || !folder) return;
    moveDocsToFolder([doc], folder);
  };

  // Takes documents out of the open folder only; they stay in the Knowledge Base and any other folders.
  const handleRemoveFromFolder = (docs) => {
    const ids = (docs || []).map((d) => d.id).filter(Boolean);
    const folder = folders.find((f) => f.id === realFolderId);
    if (!ids.length || !folder) return;
    setIsActionMenuOpen(null);
    runFolderAction({
      docs,
      folderId: folder.id,
      working: `Removing ${docsLabel(docs)} from ${folder.name}...`,
      done: `Removed ${docsLabel(docs)} from ${folder.name}`,
      failed: "Couldn't remove from this folder.",
      request: () => moveDocuments({ doc_ids: ids, from_folder_id: folder.id }),
      apply: () =>
        setFolders((prev) =>
          prev.map((f) => (f.id === folder.id ? { ...f, documents: withoutDocs(f.documents, ids) } : f))
        ),
    });
  };

  const handleDeleteFolder = async (folder, { deleteFiles = false, count = 0 } = {}) => {
    markLocalChange();
    const toastId = deleteFiles ? hotToast.loading(`Deleting “${folder.name}” and ${count} file${count === 1 ? "" : "s"}...`) : undefined;
    try {
      await api.delete(`/api/v1/rfp/knowledge-base/folders/${folder.id}/`, {
        params: { ...orgParam(), delete_documents: deleteFiles ? "true" : "false" },
      });
      const folderDocIds = new Set((folder.documents || []).map((d) => d.id));
      if (deleteFiles) {
        // The files are gone everywhere, including any other folder they were in.
        setFolders((prev) =>
          prev
            .filter((f) => f.id !== folder.id)
            .map((f) => (f.documents ? { ...f, documents: f.documents.filter((d) => !folderDocIds.has(d.id)) } : f))
        );
        setContracts((prev) => prev.filter((d) => !folderDocIds.has(d.id)));
      } else {
        // Documents that were only in this folder show under "Not in any folder" straight away.
        const orphans = (folder.documents || []).filter(
          (d) => !folders.some((f) => f.id !== folder.id && (f.documents || []).some((x) => x.id === d.id))
        );
        setFolders((prev) => prev.filter((f) => f.id !== folder.id));
        if (orphans.length) {
          setContracts((prev) => [...orphans.filter((d) => !prev.some((p) => p.id === d.id)), ...prev]);
        }
      }
      if (selectedFolderId === folder.id) {
        setSelectedFolderId(null);
        setSelectedProposalTier(null);
      }
      const message = deleteFiles
        ? `Deleted folder “${folder.name}” and ${count} file${count === 1 ? "" : "s"}`
        : `Deleted folder “${folder.name}”`;
      if (toastId) hotToast.success(message, { id: toastId });
      else hotToast.success(message);
      fetchContracts(true);
      return true;
    } catch (error) {
      const message = error?.response?.data?.error || "Couldn't delete this folder.";
      if (toastId) hotToast.error(message, { id: toastId });
      else hotToast.error(message);
      // Some files may already be gone even though the folder was kept.
      if (deleteFiles) fetchContracts(true);
      return false;
    }
  };

  const handleReorderFolders = async (folderIds) => {
    markLocalChange();
    const previous = folders;
    setFolders((prev) =>
      prev.map((f) => (folderIds.includes(f.id) ? { ...f, position: folderIds.indexOf(f.id) } : f))
    );
    try {
      await api.post("/api/v1/rfp/knowledge-base/folders/reorder/", { folder_ids: folderIds, ...orgParam() });
      fetchContracts(true);
    } catch (error) {
      setFolders(previous);
      hotToast.error(error?.response?.data?.error || "Couldn't save the folder order.");
    }
  };

  const saveDocumentOrder = async (folderId, docIds) => {
    markLocalChange();
    const previous = folders;
    setFolders((prev) =>
      prev.map((f) => (f.id === folderId ? { ...f, document_order: docIds } : f))
    );
    try {
      await api.put(`/api/v1/rfp/knowledge-base/folders/${folderId}/document-order/`, {
        doc_ids: docIds,
        ...orgParam(),
      });
      fetchContracts(true);
    } catch (error) {
      setFolders(previous);
      hotToast.error(error?.response?.data?.error || "Couldn't save the document order.");
    }
  };

  const handlePickFolder = async (folder) => {
    if (!folderPicker?.docs) return false;
    const ok = await moveDocsToFolder(folderPicker.docs, folder);
    if (ok) setFolderPicker(null);
    return ok;
  };


  function darkenColor(hex, amount = 0.4) {
    if (!hex || !hex.startsWith("#")) return "#333";
    const num = parseInt(hex.slice(1), 16);
    let r = (num >> 16) & 255,
      g = (num >> 8) & 255,
      b = num & 255;
    r = Math.floor(r * (1 - amount));
    g = Math.floor(g * (1 - amount));
    b = Math.floor(b * (1 - amount));
    return `rgb(${r}, ${g}, ${b})`;
  }


  const handleFilterClear = () => {
    setSelectedFilterTags([]);
    setFilterTagObjects([]);
    setActiveFilters({ fileTypes: [], statuses: [], tags: [] });
  };


  // Filtering runs on the loaded list (like search), so folder documents are
  // filtered too and the unfiled list is never overwritten by a filtered fetch.
  const handleFilterApply = (selectedFilters) => {
    setSelectedFilterTags(selectedFilters.tags || []);
    setActiveFilters({
      fileTypes: selectedFilters.fileTypes || [],
      statuses: selectedFilters.statuses || [],
      tags: selectedFilters.tags || [],
    });
  };


  // Flip `loading` to true BEFORE the first paint so the skeleton shows
  // immediately on (re)mount. Without this, the store's cached folders and
  // documents from a previous visit flash for a frame before `fetchContracts`
  // (which is gated on `token`, set in the effect below) sets loading=true.
  // Guarded by the auth cookie so we only show the skeleton when a fetch will
  // actually follow.
  useLayoutEffect(() => {
    if (Cookies.get("access_token")) setLoading(true);
  }, [setLoading]);

  useEffect(() => {
    const cookieToken = Cookies.get("access_token");
    if (cookieToken) setToken(cookieToken);
  }, []);


  useEffect(() => {
    verifySFDCConnection();
    verifyDriveConnection();
  }, []);


  const handleCancel = () => {
    setSelectedContracts([]);
    setPopupVisible(false);
    setConfirmDeleteVisible(false);
  };


  const orderedFolders = useMemo(() => orderFolders(folders), [folders]);


  // Every document once, with the ids of the folders it sits in. The list API
  // returns unfiled documents in `results` and filed ones inside each folder.
  const allDocuments = useMemo(() => {
    const byId = new Map();
    const add = (doc, folderId) => {
      const id = doc.id ?? doc.key ?? doc.pdf_key;
      const existing = byId.get(id);
      if (existing) {
        if (folderId !== null && !existing.folderIds.includes(folderId)) {
          existing.folderIds.push(folderId);
        }
        return;
      }
      byId.set(id, {
        ...doc,
        isFolder: false,
        file_url: doc.file_url || doc.pdf_url,
        size_mb: doc.size_mb || doc.document_size,
        uploaded_at: doc.uploaded_at || doc.created_at,
        folderIds: folderId !== null ? [folderId] : [],
      });
    };
    orderedFolders.forEach((f) => (f.documents || []).forEach((d) => add(d, f.id)));
    contracts.forEach((d) => add(d, null));
    return Array.from(byId.values());
  }, [contracts, orderedFolders]);


  const handleSort = useCallback(
    (key) => {
      if (sortKey === key) {
        setSortDir((d) => (d === "asc" ? "desc" : "asc"));
      } else {
        setSortKey(key);
        setSortDir(key === "added" ? "desc" : "asc");
      }
    },
    [sortKey]
  );


  const displayedFiles = useMemo(() => {
    const query = deferredSearchQuery.toLowerCase().trim();
    let sourceFiles = [];


    if (selectedFolderId === null) {
      sourceFiles = allDocuments;
    } else if (selectedFolderId === UNFILED) {
      sourceFiles = allDocuments.filter((doc) => doc.folderIds.length === 0);
    } else {
      sourceFiles = allDocuments.filter((doc) => doc.folderIds.includes(selectedFolderId));
      // "Won" / "Delivered" are nested VIEWS of Previous
      // Proposals, not folders of their own — every captured proposal is
      // filed in the one folder and its evidence_tier decides which child
      // it shows under. See rfp.services.kb_folders on the backend.
      if (selectedProposalTier) {
        // "past_proposal" is the catch-all child — anything not Won or
        // Delivered, so a legacy document with no tier (or 'claimed') still
        // shows up there rather than vanishing from every child.
        sourceFiles = sourceFiles.filter((doc) => {
          const tier = ["won", "delivered"].includes(doc.evidence_tier)
            ? doc.evidence_tier
            : "past_proposal";
          return tier === selectedProposalTier;
        });
      }
    }


    let filtered = sourceFiles;


    if (activeFilters.fileTypes && activeFilters.fileTypes.length > 0) {
      const allowedTypes = activeFilters.fileTypes.map((t) => t.toLowerCase());
      filtered = filtered.filter((file) => {
        const fileExt =
          file.file_type?.toLowerCase() ||
          file.name?.split(".").pop()?.toLowerCase() ||
          "";


        if (
          allowedTypes.includes("xlsx") &&
          (fileExt === "xlsx" || fileExt === "xls" || fileExt === "csv")
        )
          return true;
        if (
          allowedTypes.includes("docx") &&
          (fileExt === "docx" || fileExt === "doc" || fileExt === "txt")
        )
          return true;
        if (allowedTypes.includes("pdf") && fileExt === "pdf") return true;


        return allowedTypes.includes(fileExt);
      });
    }


    if (activeFilters.statuses && activeFilters.statuses.length > 0) {
      const allowedStatuses = activeFilters.statuses.map((s) =>
        s.toLowerCase().replace(/ /g, "_")
      );
      filtered = filtered.filter((file) => {
        const status = file.status?.toLowerCase() || "";
        return allowedStatuses.includes(status);
      });
    }


    if (activeFilters.tags && activeFilters.tags.length > 0) {
      const wanted = activeFilters.tags.map((t) => t.toLowerCase());
      filtered = filtered.filter((file) =>
        (file.tags || []).some((tag) => wanted.includes((tag.name || "").toLowerCase()))
      );
    }


    if (query) {
      filtered = filtered.filter((file) => {
        const fileName = file.name?.toLowerCase() || "";
        const fileTags = Array.isArray(file.tags)
          ? file.tags.map((tag) => tag.name?.toLowerCase() || "").join(" ")
          : "";
        const fileType = file.file_type?.toLowerCase() || "";
        return (
          fileName.includes(query) ||
          fileTags.includes(query) ||
          fileType.includes(query)
        );
      });
    }


    const currentFolder = realFolderId ? orderedFolders.find((f) => f.id === realFolderId) : null;
    const customOrder =
      currentFolder && !selectedProposalTier && currentFolder.name !== "Previous Proposals"
        ? currentFolder.document_order
        : null;
    if (customOrder && customOrder.length) {
      return applyDocumentOrder(sortDocuments(filtered, "added", "desc"), customOrder);
    }
    return sortDocuments(filtered, sortKey, sortDir);
  }, [
    allDocuments,
    orderedFolders,
    realFolderId,
    selectedFolderId,
    selectedProposalTier,
    deferredSearchQuery,
    activeFilters,
    sortKey,
    sortDir,
  ]);


  // A document can sit in several folders, so the delete warning says where it will disappear from.
  // Bulk delete only sends rows that are on screen, so the message counts the same rows.
  const deleteTargets = confirmDeleteVisible
    ? isBulkDelete
      ? displayedFiles.filter((d) => selectedContracts.includes(d.id))
      : allDocuments.filter((d) => (contractToDelete?.doc_ids || []).includes(d.id))
    : [];
  const deleteTitle =
    deleteTargets.length === 1
      ? `Delete “${deleteTargets[0].name}”?`
      : `Delete ${deleteTargets.length || "the selected"} documents?`;
  const deleteWarning = (() => {
    if (!confirmDeleteVisible) return "";
    const docs = deleteTargets;
    const nameOf = (id) => folders.find((f) => f.id === id)?.name;
    const joinNames = (names) =>
      names.length > 1 ? `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}` : names[0];
    const openFolder = folders.find((f) => f.id === realFolderId);
    const removeHint = openFolder
      ? ` To take ${docs.length > 1 ? "them" : "it"} out of ${openFolder.name} only, use Remove from folder instead.`
      : "";
    if (docs.length === 1) {
      const names = docs[0].folderIds.map(nameOf).filter(Boolean);
      if (!names.length) return "";
      return names.length === 1
        ? `It will also disappear from the ${names[0]} folder.${removeHint}`
        : `It will also disappear from all ${names.length} folders it's in: ${joinNames(names)}.${removeHint}`;
    }
    const filed = docs.filter((d) => d.folderIds.length > 0).length;
    if (!filed) return "";
    return `${filed} of these documents ${filed === 1 ? "is" : "are"} in folders and will disappear from every folder ${filed === 1 ? "it's" : "they're"} in.${removeHint}`;
  })();


  const isAllChecked =
    selectedContracts.length === displayedFiles.length &&
    displayedFiles.length > 0 &&
    displayedFiles.every((item) => item.id);


  const handleSelectAll = useCallback(() => {
    if (isAllChecked) {
      setSelectedContracts([]);
      setSelectedContractKeys([]);
    } else {
      const allIds = displayedFiles.map((item) => item.id).filter(Boolean);
      const allKeys = displayedFiles.map((item) => item.key).filter(Boolean);
      setSelectedContracts(allIds);
      setSelectedContractKeys(allKeys);
    }
  }, [isAllChecked, displayedFiles]);


  const handleCheckboxChange = useCallback((id, key) => {
    if (!id) return;
    setSelectedContracts((prev) =>
      prev.includes(id) ? prev.filter((cId) => cId !== id) : [...prev, id]
    );
    setSelectedContractKeys((prev) =>
      prev.includes(key) ? prev.filter((cKey) => cKey !== key) : [...prev, key]
    );
  }, []);


  // A selection only makes sense for the rows on screen, so any change of view clears it.
  useEffect(() => {
    setSelectedContracts([]);
    setSelectedContractKeys([]);
    setIsActionMenuOpen(null);
  }, [selectedFolderId, selectedProposalTier, deferredSearchQuery, activeFilters]);

  // If the open folder disappears (deleted by someone else), go back to All Files.
  useEffect(() => {
    if (loading || !realFolderId || !folders.length) return;
    if (!folders.some((f) => f.id === realFolderId)) {
      setSelectedFolderId(null);
      setSelectedProposalTier(null);
      // A Move picker for that folder has nothing to move from any more.
      if (folderPicker?.mode === "move") {
        setFolderPicker(null);
        hotToast.error("The folder you were in was deleted.");
      }
    }
  }, [folders, realFolderId, loading]); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    if (token) fetchContracts();
  }, [token, fetchContracts]);


  const [actionMenuPosition, setActionMenuPosition] = useState({
    top: 0,
    left: 0,
    openUpwards: false,
  });
  const toggleActionMenu = useCallback((index, event) => {
    const MENU_HEIGHT = 330; 
    const rect = event.currentTarget.getBoundingClientRect();
    const bottomSpace = window.innerHeight - rect.bottom;
    const openUpwards = bottomSpace < MENU_HEIGHT;
  
    setIsActionMenuOpen((prev) => (prev === index ? null : index));
    setActionMenuPosition({
      top: openUpwards ? rect.top : rect.bottom + 4,
      left: rect.right,
      openUpwards,
    });
  }, []);


  const handleClickOutside = (event) => {
    if (
      isActionMenuOpen !== null &&
      actionMenuRefs.current[isActionMenuOpen] &&
      !actionMenuRefs.current[isActionMenuOpen].contains(event.target)
    ) {
      setIsActionMenuOpen(null);
    }
    if (
      confirmDeleteVisible &&
      event.target.closest(".popup-overlay") === null &&
      !event.target.closest(".kb-delete-confirm")
    ) {
      setConfirmDeleteVisible(false);
    }
  };


  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [confirmDeleteVisible, isActionMenuOpen]);


  const showPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setPopupVisible(true);
  };
  const closePopup = () => setPopupVisible(false);


  const handleDelete = useCallback((item) => {
    setIsActionMenuOpen(null);
    setIsBulkDelete(false);
    setContractToDelete({ folder_ids: [], doc_ids: [item.id] });
    setConfirmDeleteVisible(true);
  }, []);


  const handleBulkDelete = useCallback(() => {
    if (!selectedContracts || selectedContracts.length === 0) {
      showPopup("Error", "Please select at least one item to delete.");
      return;
    }
    setIsActionMenuOpen(null);
    setIsBulkDelete(true);
    setConfirmDeleteVisible(true);
  }, [selectedContracts]);


  const confirmDelete = async () => {
    let payload;
    if (isBulkDelete) {
      const selectedItems = displayedFiles.filter((item) =>
        selectedContracts.includes(item.id)
      );
      const doc_ids = selectedItems.map((item) => item.id).filter(Boolean);
      payload = { doc_ids, folder_ids: [] };
    } else {
      payload = contractToDelete;
    }


    setDeleteInProgress(true);
    try {
      const res = await api.delete(
        "/api/v1/rfp/knowledge-base/documents/delete/",
        { data: payload }
      );
      if (res.status === 200 || res.status === 204) {
        const documents = res?.data?.results?.documents || [];
        const foldersList = res?.data?.results?.folders || [];
        const allItems = [...documents, ...foldersList];
        const failedItems = allItems.filter((item) => item.status === "error" || item.status === "failed");
        
        // BUG FIX: API returns "deleted", not "success"
        const deletedDocIds = documents
          .filter((item) => item.status === "success" || item.status === "deleted")
          .map((item) => item.identifier);
        const deletedFolderIds = foldersList
          .filter((item) => item.status === "success" || item.status === "deleted")
          .map((item) => item.identifier);


        setDeleteInProgress(false);


        if (failedItems.length > 0) {
          failedItems.forEach((item) => {
            hotToast.error(
              `Failed to delete (ID: ${item.identifier}): ${item.error || "Unknown error"}`
            );
          });
        }


        if (deletedDocIds.length > 0 || deletedFolderIds.length > 0) {
          // OPTIMISTIC UPDATE: Instantly remove deleted items from UI 
          setContracts((prev) => prev.filter((item) => !deletedDocIds.includes(item.id)));
          setFolders((prev) => prev.map(f => ({
            ...f,
            documents: (f.documents || []).filter(d => !deletedDocIds.includes(d.id))
          })).filter(f => !deletedFolderIds.includes(f.id)));
          setResults((prev) => prev.filter((item) => !deletedDocIds.includes(item.id)));

          // BACKGROUND REFRESH: fetch strictly the specific API to keep table synced cleanly
          const orgId = Cookies.get("selected_org_id");
          const docsUrl = orgId
            ? `/api/v1/rfp/knowledge-base/documents/?organization_id=${encodeURIComponent(orgId)}`
            : "/api/v1/rfp/knowledge-base/documents/";

          api.get(docsUrl)
            .then((docsResponse) => {
              if (docsResponse && docsResponse.data) {
                const { results: fetchedResults, folders: fetchedFolders } = docsResponse.data;
                
                const currentDocs = [
                  ...(contractsRef.current || []),
                  ...(foldersRef.current || []).flatMap((f) => f.documents || []),
                ];
                
                const getPreservedStatus = (docKey, docId) => {
                  const existing = currentDocs.find(
                    (d) => (d.pdf_key || d.key) === docKey || d.id === docId
                  );
                  return existing?.status || "processing";
                };

                const updatedFolders = (fetchedFolders || []).map((folder) => ({
                  ...folder,
                  documents: (folder.documents || []).map((doc) => {
                    const docKey = doc.pdf_key || doc.key;
                    return {
                      ...doc,
                      status: doc.status ? doc.status : getPreservedStatus(docKey, doc.id),
                    };
                  }),
                }));

                const updatedResults = (fetchedResults || []).map((doc) => {
                  const docKey = doc.pdf_key || doc.key;
                  return {
                    ...doc,
                    status: doc.status ? doc.status : getPreservedStatus(docKey, doc.id),
                  };
                });
                keepUploadPlaceholders(uploadPlaceholdersRef.current, updatedFolders, updatedResults);

                setResults(updatedResults);
                setFolders(updatedFolders);
                setContracts(updatedResults);
              }
            })
            .catch((error) => console.error("Error refreshing documents after delete:", error));
        }


        if (deletedDocIds.length > 0 || deletedFolderIds.length > 0 || allItems.length === 0) {
          setDeleteSuccess(true);
          setTimeout(() => {
            setConfirmDeleteVisible(false);
            setDeleteSuccess(false);
            setContractToDelete(null);
            setSelectedContracts([]);
            setSelectedContractKeys([]);
          }, 500);
        } else {
          setConfirmDeleteVisible(false);
          setContractToDelete(null);
          setSelectedContracts([]);
          setSelectedContractKeys([]);
        }
      }
    } catch (error) {
      setDeleteInProgress(false);
      setDeleteSuccess(false);
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to delete item(s).";
      hotToast.error(errorMessage);
    }
  };


  const formatDate = useCallback((dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const day = String(date.getDate()).padStart(2, "0"),
      month = String(date.getMonth() + 1).padStart(2, "0"),
      year = date.getFullYear().toString().slice(-2);
    return `${month}-${day}-${year}`;
  }, []);


  const getFileIcon = useCallback((item) => {
    switch (item.file_type) {
      case "pdf":
        return "/pdff.svg";
      case "xlsx":
      case "xls":
        return "/Xls.svg";
      case "docx":
      case "doc":
        return "/docX.svg";
      case "csv":
        return "/CSV.svg";
      case "txt":
        return "/TXT.svg";
      default:
        return "/pdf.svg";
    }
  }, []);


  const handleDownload = useCallback(async (item) => {
    setIsActionMenuOpen(null);
    const fileName = item.name || `document.${item.file_type || "file"}`;
    try {
      const response = await fetch(item.file_url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download error:", error);
      const opened = window.open(item.file_url, "_blank", "noopener,noreferrer");
      if (!opened) hotToast.error("Failed to download file.");
    }
  }, []);


  const hasSelectedFiles = () => selectedContracts.length > 0;
  const getSelectedFilesCount = () => selectedContracts.length;


  const handleMoveToFolder = () => {
    const docs = displayedFiles.filter((d) => d.id && selectedContracts.includes(d.id));
    if (docs.length) setFolderPicker({ mode: "move", docs });
  };

  const handleSingleMoveToFolder = useCallback((item) => {
    setIsActionMenuOpen(null);
    if (item?.id) setFolderPicker({ mode: "move", docs: [item] });
  }, []);


  const removeFileExtension = useCallback((filename) => {
    if (!filename) return "N/A";
    if (filename.includes(".")) {
      const lastDotIndex = filename.lastIndexOf(".");
      if (lastDotIndex > 0) return filename.substring(0, lastDotIndex);
    }
    return filename;
  }, []);


  const handleRenameClick = useCallback((item) => {
    setIsActionMenuOpen(null);
    setRenameItem(item);
    setIsRenameModalOpen(true);
  }, []);


  const handleRenameSubmit = async (newName) => {
    if (!renameItem || !newName.trim()) return;
    setRenameLoading(true);
    try {
      const response = await api.put(
        `/api/v1/readpdf/rename-doc/${renameItem.id}/`,
        { new_name: newName }
      );
      if (response.status === 200) {
        hotToast.success(`File renamed successfully!`);
        setIsRenameModalOpen(false);
        setRenameItem(null);
        fetchContracts();
      }
    } catch (error) {
      hotToast.error("Failed to rename file");
    } finally {
      setRenameLoading(false);
    }
  };


  const handleCloseRenameModal = () => {
    setIsRenameModalOpen(false);
    setRenameItem(null);
  };


  const handleViewAndIngestOpen = useCallback((item) => {
    setIsActionMenuOpen(null);
    setViewAndIngestItem(item);
    // The summary and folder check finish in the background, so get the latest.
    fetchContracts(true);
  }, [fetchContracts]);

  // The open window follows the row, so a move or a fresher summary shows straight away.
  const viewAndIngestLive = viewAndIngestItem
    ? allDocuments.find((d) => d.id === viewAndIngestItem.id) || viewAndIngestItem
    : null;


  const handleViewAndIngestClose = useCallback(() => {
    setViewAndIngestItem(null);
  }, []);


  const handleApproveAndIngest = async (item) => {
    const pdfKey = item.pdf_key || item.key;
    try {
      await api.post(`/api/v1/rfp/knowledge-base/documents/${pdfKey}/ingest/`, {
        action: "approve",
      });


      setActivePollingDocs((prev) => new Set([...prev, pdfKey]));


      const updateDocStatus = (docs) =>
        docs.map((doc) =>
          (doc.pdf_key || doc.key) === pdfKey
            ? { ...doc, status: "processing" }
            : doc
        );


      setContracts((prev) => updateDocStatus(prev));
      setFolders((prev) =>
        prev.map((f) => ({
          ...f,
          documents: updateDocStatus(f.documents || []),
        }))
      );


      setTimeout(() => pollDocumentStatuses(), 1000);
    } catch (error) {
      hotToast.error("Failed to start ingestion.");
      throw error;
    }
  };


  const handleRejectAndDelete = async (item) => {
    const pdfKey = item.pdf_key || item.key;
    try {
      await api.delete(
        `/api/v1/rfp/knowledge-base/documents/${pdfKey}/reject/`
      );
      
      // OPTIMISTIC UPDATE
      setContracts((prev) => prev.filter((d) => (d.pdf_key || d.key) !== pdfKey));
      setFolders((prev) => prev.map(f => ({
        ...f,
        documents: (f.documents || []).filter(d => (d.pdf_key || d.key) !== pdfKey)
      })));
      setResults((prev) => prev.filter((d) => (d.pdf_key || d.key) !== pdfKey));

      // BACKGROUND REFRESH
      const orgId = Cookies.get("selected_org_id");
      const docsUrl = orgId
        ? `/api/v1/rfp/knowledge-base/documents/?organization_id=${encodeURIComponent(orgId)}`
        : "/api/v1/rfp/knowledge-base/documents/";

      api.get(docsUrl).then(docsResponse => {
        if (docsResponse && docsResponse.data) {
          const { results: fetchedResults, folders: fetchedFolders } = docsResponse.data;
          const currentDocs = [
            ...(contractsRef.current || []),
            ...(foldersRef.current || []).flatMap((f) => f.documents || []),
          ];
          const getPreservedStatus = (docKey, docId) => {
            const existing = currentDocs.find((d) => (d.pdf_key || d.key) === docKey || d.id === docId);
            return existing?.status || "processing";
          };
          const updatedFolders = (fetchedFolders || []).map((folder) => ({
            ...folder,
            documents: (folder.documents || []).map((doc) => {
              const docKey = doc.pdf_key || doc.key;
              return { ...doc, status: doc.status ? doc.status : getPreservedStatus(docKey, doc.id) };
            }),
          }));
          const updatedResults = (fetchedResults || []).map((doc) => {
            const docKey = doc.pdf_key || doc.key;
            return { ...doc, status: doc.status ? doc.status : getPreservedStatus(docKey, doc.id) };
          });
          keepUploadPlaceholders(uploadPlaceholdersRef.current, updatedFolders, updatedResults);
          setResults(updatedResults);
          setFolders(updatedFolders);
          setContracts(updatedResults);
        }
      }).catch(e => console.error("Error background refreshing reject delete:", e));

    } catch (error) {
      hotToast.error("Failed to reject document.");
      throw error;
    }
  };


  // Only meaningful inside "Previous Proposals" — see AllSources.jsx/DataTable.jsx.
  // Moving a document between Submitted/Won/Delivered is purely a tier
  // change on rfp.services.kb_folders' side; no folder membership moves.
  const handleSetProposalTier = async (item, tier) => {
    try {
      await api.patch(`/api/v1/rfp/knowledge-base/documents/${item.id}/evidence-tier/`, {
        evidence_tier: tier,
      });

      const updateTier = (docs) =>
        docs.map((doc) => (doc.id === item.id ? { ...doc, evidence_tier: tier } : doc));

      setContracts((prev) => updateTier(prev));
      setFolders((prev) =>
        prev.map((f) => ({ ...f, documents: updateTier(f.documents || []) }))
      );

      const labels = { won: "Won", past_proposal: "Submitted", delivered: "Delivered" };
      hotToast.success(`Moved to ${labels[tier] || tier}.`);
    } catch (error) {
      console.error("Set proposal tier error:", error);
      hotToast.error("Couldn't update this document.");
    }
  };


  const handleViewDocumentFromModal = (item) => {
    setSelectedFilePreview({
      pdf_url: item.file_url || item.pdf_url,
      file_type: item.file_type,
      name: item.name,
    });
  };


  const tabs = [
    { name: "All Sources", path: "/rfp-knowledgeBase/All-sources" },
    // Beside the documents rather than in account settings: this is what the
    // system READ OUT of those documents, so it belongs where someone can see
    // the source and the conclusion together.
    { name: "Memory", path: "/rfp-knowledgeBase/Memory" },
    { name: "Content Library", path: "/rfp-knowledgeBase/Content-library" },
    { name: "Integrations", path: "/rfp-knowledgeBase/Integrations" },
  ];

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        className="hidden"
        accept=".pdf,.jpeg,.jpg,.png,.csv,.xlsx,.xls,.docx,.doc"
        onChange={handleFileChange}
      />


      <div className="flex flex-col w-full h-full min-h-0 overflow-hidden bg-[#FAFAFA]">
        <div className="flex-shrink-0 bg-white">
          <Header
            name="Knowledge Base"
            icon={""}
            isMenuOpen={isMenuOpen}
            isKnowledgeBasePage={true}
            kbState={{
              isKnowledgeBaseEmpty,
              isDriveConnected,
              // Keep "Add From Drive" disabled while the SDK is still loading or
              // a picker/import is already in flight, so a double click can't
              // start two concurrent imports.
              pickerLoaded: pickerLoaded && !isOpeningDrivePicker && !isImportingFromDrive,
              isSFDCConnected,
              isReviewer,
            }}
            kbHandlers={{
              onChat: handleChatButtonClick,
              onCreateFolder: startCreateFolder,
              onAddDevice: () => fileInputRef.current?.click(),
              onConnectDrive: handleConnectDrive,
              onAddFromDrive: openPicker,
              onConnectSFDC: handleConnectSFDC,
              onAddFromSFDC: handleFetchSFDCFiles,
            }}
          />
        </div>


        <div className="flex justify-between items-center px-6 pt-2 pb-0 border-b border-[#00000036] bg-white flex-shrink-0 w-full">
          <div className="flex items-center gap-4 border-b-[1px]">
            {tabs.map((tab) => (
              <button
                key={tab.name}
                onClick={() => navigate(tab.path)}
                className={`font-outfit text-[15px] pb-0 px-1 transition-colors ${
                  currentPath.includes(tab.path.toLowerCase())
                    ? "text-[#BB42AE] font-semibold border-b-[2px] border-[#BB42AE]"
                    : "text-[#707070] font-medium  border-[#E6E6E6]"
                }`}
              >
                {tab.name}
              </button>
            ))}
          </div>


          {/* Filter, Columns and document search act on the All Sources
              table; under Memory they have nothing to operate on.
              INVISIBLE, NOT HIDDEN: display:none collapses the row and the
              tab bar above jumps upward as you switch tabs. Keeping the
              space holds every tab at the same position. */}
          <div className={`flex items-center gap-3 pb-3 ${currentPath.includes("/rfp-knowledgebase/memory") ? "invisible pointer-events-none" : ""}`}>
          <div className="relative inline-flex items-center gap-2 z-[50]">
            <FilterDropdown
              folderId={selectedFolderId}
              initialFilters={activeFilters}
              onApply={handleFilterApply}
              onClear={handleFilterClear}
              tagsRefreshTrigger={tagsRefreshTrigger}
            />
          </div>


            <div className="relative inline-flex items-center gap-2">
              <button
                onClick={() => setIsColumnDropdownOpen((p) => !p)}
                className={`flex items-center gap-2 px-3 py-1.5 border rounded text-[14px] font-outfit transition-colors ${
                  isColumnDropdownOpen
                    ? "border-[#BB42AE] text-[#BB42AE] bg-[#F8F3FF]"
                    : "border-[#00000036] text-[#52525B] hover:bg-gray-50"
                }`}
              >
                <ColumnIcon /> Columns
              </button>
              {isColumnDropdownOpen && (
                <>
                  <div
                    className="fixed inset-0 z-[998] bg-transparent"
                    onClick={() => setIsColumnDropdownOpen(false)}
                  />
                  <ColumnDropdown
                    columns={columnPreferences}
                    setColumns={setColumnPreferences}
                    onSave={saveColumnPreferences}
                    onClose={() => setIsColumnDropdownOpen(false)}
                  />
                </>
              )}
            </div>


            <div className="relative w-[200px]">
              <Search
                className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600"
                size={18}
              />
              <input
                type="text"
                placeholder="Search Documents..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onFocus={() => setIsSearchFocused(true)}
                onBlur={() => setIsSearchFocused(false)}
                className="w-full pl-10 pr-4 border border-[#00000036] rounded-md focus:outline-none focus:border-[#C95EBE] focus:ring-1 focus:ring-[#C95EBE] box-border h-[35px] text-[14px] leading-[20px] transition-all"
              />
            </div>
          </div>
        </div>


        {currentPath.includes("/rfp-knowledgebase/all-sources") && (
          <AllSources
            allDocuments={allDocuments}
            folders={orderedFolders}
            selectedFolderId={selectedFolderId}
            setSelectedFolderId={setSelectedFolderId}
            selectedProposalTier={selectedProposalTier}
            setSelectedProposalTier={setSelectedProposalTier}
            isCreatingFolder={isCreatingFolderInline}
            onStartCreateFolder={startCreateFolder}
            onCancelCreateFolder={() => {
              setIsCreatingFolderInline(false);
              setDraftFolderName("");
            }}
            onCreateFolder={handleInlineCreateFolder}
            onRenameFolder={handleRenameFolder}
            draggingDoc={draggingDoc}
            setDraggingDoc={setDraggingDoc}
            onDropDocOnFolder={handleMoveDocToFolder}
            onDeleteFolder={handleDeleteFolder}
            onRemoveFromFolder={handleRemoveFromFolder}
            pendingDocIds={pendingActions.flatMap((p) => p.docIds)}
            pendingFolderIds={pendingActions.map((p) => p.folderId)}
            creatingFolderName={creatingFolderName}
            onDocumentReplaced={(doc) => {
              // Show it as processing first, or the polling clean-up drops it while the row still says ingested.
              markLocalChange();
              const asUploading = (d) => ((d.pdf_key || d.key) === doc?.key ? { ...d, status: "uploading" } : d);
              setContracts((prev) => prev.map(asUploading));
              setResults((prev) => (prev || []).map(asUploading));
              setFolders((prev) => prev.map((f) => (f.documents ? { ...f, documents: f.documents.map(asUploading) } : f)));
              if (doc?.key) setActivePollingDocs((prev) => new Set([...prev, doc.key]));
              fetchContracts(true);
            }}
            onDocumentsChanged={() => {
              markLocalChange();
              fetchContracts(true);
            }}
            onSourceUploaded={(key) => {
              markLocalChange();
              if (key) setActivePollingDocs((prev) => new Set([...prev, key]));
              fetchContracts(true);
            }}
            onFolderCheckMove={handleFolderCheckMove}
            onFolderCheckKeep={handleFolderCheckKeep}
            draftFolderName={draftFolderName}
            onReorderFolders={handleReorderFolders}
            onSaveDocumentOrder={saveDocumentOrder}
            onUploadClick={() => fileInputRef.current?.click()}
            isFiltered={
              !!deferredSearchQuery.trim() ||
              activeFilters.fileTypes.length > 0 ||
              activeFilters.statuses.length > 0 ||
              activeFilters.tags.length > 0
            }
            sortKey={sortKey}
            sortDir={sortDir}
            onSort={handleSort}
            selectedContracts={selectedContracts}
            getSelectedFilesCount={getSelectedFilesCount}
            hasSelectedFiles={hasSelectedFiles}
            handleMoveToFolder={handleMoveToFolder}
            handleSingleMoveToFolder={handleSingleMoveToFolder}
            handleBulkDelete={handleBulkDelete}
            handleCancel={handleCancel}
            displayedFiles={displayedFiles}
            loading={loading}
            isAllChecked={isAllChecked}
            handleSelectAll={handleSelectAll}
            handleCheckboxChange={handleCheckboxChange}
            getFileIcon={getFileIcon}
            removeFileExtension={removeFileExtension}
            darkenColor={darkenColor}
            openTagModalFor={openTagModalFor}
            applyingTagDocIds={applyingTagDocIds}
            formatDate={formatDate}
            toggleActionMenu={toggleActionMenu}
            isActionMenuOpen={isActionMenuOpen}
            setIsActionMenuOpen={setIsActionMenuOpen}
            actionMenuPosition={actionMenuPosition}
            actionMenuRefs={actionMenuRefs}
            setSelectedFilePreview={setSelectedFilePreview}
            handleRenameClick={handleRenameClick}
            handleDownload={handleDownload}
            handleDelete={handleDelete}
            handleViewAndIngest={handleViewAndIngestOpen}
            handleSetProposalTier={handleSetProposalTier}
            columnPreferences={columnPreferences}
            isReviewer={isReviewer}
          />
        )}


        {currentPath.includes("/rfp-knowledgebase/memory") && (
          <div className="min-h-0 flex-1 overflow-hidden bg-white px-6 pt-6">
            <OrganizationMemory isReviewer={isReviewer} />
          </div>
        )}
        {currentPath.includes("/rfp-knowledgebase/content-library") && <ContentLibrary />}
        {currentPath.includes("/rfp-knowledgebase/integrations") && <Integrations />}


        {popupVisible && (
          <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
            <div className="popup-box">
              <h2>{popupTitle}</h2> <p>{popupMessage}</p>
              <button onClick={closePopup} className="popup-close-button">
                Close
              </button>
            </div>
          </div>
        )}


        {confirmDeleteVisible && (
          <div className="fixed inset-0 z-[9999] bg-[rgba(24,16,28,0.45)] flex items-center justify-center">
            <div className="kb-delete-confirm w-[440px] max-w-[92vw] bg-white rounded-xl p-6 shadow-[0_24px_48px_rgba(24,16,28,0.3)] flex flex-col gap-3 font-outfit">
              <p className="m-0 text-[18px] font-semibold text-[#18181B] break-words">{deleteTitle}</p>
              {deleteWarning && (
                <p className="m-0 text-[14px] leading-[1.55] text-[#27272A] break-words">{deleteWarning}</p>
              )}
              <p className="m-0 text-[14px] leading-[1.55] text-[#3F3F46]">
                {deleteTargets.length > 1
                  ? "This permanently removes them from the Knowledge Base and can't be undone."
                  : "This permanently removes it from the Knowledge Base and can't be undone."}
              </p>
              <div className="flex justify-end gap-[10px] mt-2">
                <button
                  type="button"
                  onClick={() => setConfirmDeleteVisible(false)}
                  disabled={deleteInProgress || deleteSuccess}
                  className="px-4 py-2 border border-[#A1A1AA] rounded-md bg-white text-[#27272A] text-[14px] font-medium disabled:opacity-50"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={confirmDelete}
                  disabled={deleteInProgress || deleteSuccess}
                  className="px-4 py-2 border border-[#B42318] rounded-md bg-[#B42318] hover:bg-[#912018] text-white text-[14px] font-medium disabled:opacity-50"
                >
                  {deleteInProgress ? "Deleting..." : deleteSuccess ? "Deleted" : "Delete"}
                </button>
              </div>
            </div>
          </div>
        )}


        {selectedFilePreview && (
          <div
            className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 backdrop-blur-sm"
            onClick={() => setSelectedFilePreview(null)}
          >
            <div
              className="bg-white rounded-lg shadow-lg w-[55vw] h-[80vh] overflow-hidden relative"
              onClick={(e) => e.stopPropagation()}
            >
              <PdfViewer
                pdfUrl={selectedFilePreview.pdf_url}
                highlightPage={Number(selectedFilePreview.page) || 1}
              />
            </div>
          </div>
        )}


        {isTagModalOpen && (
          <CreateTagModals
            isOpen={isTagModalOpen}
            onClose={() => setIsTagModalOpen(false)}
            documentId={tagModalDocIds}
            displayedFiles={displayedFiles}
            onTagUpdate={async () => {
              const ids = tagModalDocIds;
              setApplyingTagDocIds(ids);
              setTagsRefreshTrigger((prev) => prev + 1);
              try {
                // Silent refresh: keep the table on screen instead of reloading
                // the whole page (isPolling=true skips the loading spinner).
                await fetchContracts(true);
              } finally {
                setApplyingTagDocIds([]);
              }
            }}
            onClearSelection={() => {
              setSelectedContracts([]);
              setSelectedContractKeys([]);
            }}
          />
        )}


        {isCreateFolderModalOpen && (
          <CreateFolderModal
            isOpen={isCreateFolderModalOpen}
            onClose={closeCreateFolderModal}
            onCreate={handleCreateFolder}
            token={token}
          />
        )}


        {showSuccessPopup && (
          <SuccessPopup
            isOpen={showSuccessPopup}
            message={successMessage}
            onClose={() => setShowSuccessPopup(false)}
          />
        )}


        {showSFDCFileList && (
          <SalesforceFileModal
            show={showSFDCFileList}
            onClose={() => setShowSFDCFileList(false)}
            sfdcFiles={sfdcFiles}
            onSelect={handleSelectSFDCFiles}
            isFetching={isFetchingSFDCFiles}
          />
        )}


        {folderPicker && (
          <FolderPickerModal
            docs={folderPicker.docs}
            folders={orderedFolders}
            currentFolder={folders.find((f) => f.id === realFolderId) || null}
            onPick={handlePickFolder}
            onCreateFolder={createFolderQuietly}
            onClose={() => setFolderPicker(null)}
          />
        )}


        {isRenameModalOpen && (
          <RenameModal
            isOpen={isRenameModalOpen}
            onClose={handleCloseRenameModal}
            onRename={handleRenameSubmit}
            currentName={renameItem?.name || ""}
            loading={renameLoading}
            isFolder={renameItem?.isFolder || false}
            itemType={renameItem?.isFolder ? "folder" : "file"}
          />
        )}


        {!!viewAndIngestItem && (
          <ViewAndIngestModal
            isOpen={!!viewAndIngestItem}
            onClose={handleViewAndIngestClose}
            item={viewAndIngestLive}
            onRejectAndDelete={handleRejectAndDelete}
            onApproveAndIngest={handleApproveAndIngest}
            onViewDocument={handleViewDocumentFromModal}
            isReviewer={isReviewer}
            folderName={folders.find((f) => f.id === viewAndIngestLive?.folderIds?.[0])?.name || null}
            onFolderCheckMove={handleFolderCheckMove}
            onFolderCheckKeep={handleFolderCheckKeep}
          />
        )}


        {dupNotice && (
          <DuplicateUploadModal
            items={dupNotice.items}
            otherCount={dupNotice.otherCount}
            onClose={() => setDupNotice(null)}
          />
        )}


        {isImportingFromDrive && (
          <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/30 backdrop-blur-[2px]">
            <div className="bg-white rounded-xl shadow-lg w-[400px] max-h-[70vh] flex flex-col p-5">
              <h2 className="text-[16px] font-semibold text-[#1A1A1A] font-[Outfit] mb-1">
                Importing from Google Drive…
              </h2>
              <p className="text-[13px] text-[#71717A] font-[Outfit] mb-3">
                We&apos;re fetching your{" "}
                {driveImportItems.length > 1 ? "files" : "file"} from Drive. They&apos;ll
                appear in the table as soon as they&apos;re in.
              </p>
              <div
                className="overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-[rgba(115,96,123,0.4)]"
                style={{ maxHeight: "200px" }}
              >
                {driveImportItems.map((item) => (
                  <div
                    key={item.id}
                    className="mb-3 last:mb-0 border border-[rgba(0,0,0,0.06)] rounded-lg px-3 py-2 bg-[#FFF]"
                  >
                    <div className="flex items-center justify-between gap-2">
                      <div className="text-[14px] font-medium text-[#171717] font-[Outfit] truncate">
                        {item.name}
                      </div>
                      <SpinnerIcon className="animate-spin h-5 w-5 text-[#8B55DD] flex-shrink-0" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}


        {isSFDCUploading && (
          <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/30 backdrop-blur-[2px]">
            <div className="bg-white rounded-xl shadow-lg w-[400px] max-h-[70vh] flex flex-col p-5">
              <h2 className="text-[16px] font-semibold text-[#1A1A1A] font-[Outfit] mb-1">
                Uploading from Salesforce…
              </h2>
              <div
                className="overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-[rgba(115,96,123,0.4)]"
                style={{ maxHeight: "200px" }}
              >
                {sfdcUploadItems.map((item) => (
                  <div
                    key={item.id}
                    className="mb-4 last:mb-0 border border-[rgba(0,0,0,0.06)] rounded-lg px-3 py-2 bg-[#FFF]"
                  >
                    <div className="flex items-start justify-between">
                      <div className="flex-1 min-w-0">
                        <div className="text-[14px] font-medium text-[#171717] font-[Outfit] truncate">
                          {item.title}
                        </div>
                      </div>
                      <div className="ml-2 flex-shrink-0">
                        {item.status === "completed" ? (
                          <img src="/right-success-upload.svg" alt="Done" className="w-5 h-5" />
                        ) : item.status === "error" || item.status === "failed" ? (
                          <img src="/cross-icon.svg" alt="Error" className="w-5 h-5" />
                        ) : (
                          <SpinnerIcon className="animate-spin h-5 w-5 text-[#8B55DD]" />
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};


export default KnowledgeBase;
